import 'moment';
import _, { isEmpty, sortBy } from 'lodash';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/** @format */
var feedsCloudFunctions = function feedsCloudFunctions(Firebase) {
  var functions = Firebase.functions;
  return {
    loadFeed: function () {
      var _loadFeed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(feedTypeUuid, start, filters) {
        var feedMode,
            callableFn,
            props,
            result,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                feedMode = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
                callableFn = functions.httpsCallable("backendFeedsLoadFeed");
                props = _objectSpread2({
                  return_feed: feedMode,
                  feedTypeUuid: feedTypeUuid
                }, filters);

                if (start !== null) {
                  props.start = start;
                }

                _context.next = 6;
                return callableFn(props);

              case 6:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function loadFeed(_x, _x2, _x3) {
        return _loadFeed.apply(this, arguments);
      }

      return loadFeed;
    }(),
    searchInFeed: function () {
      var _searchInFeed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(feedTypeUuid, searchFeedTypeUuid, searchTerms, start) {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return functions.httpsCallable("backendFeedsSearchInFeed")({
                  feedTypeUuid: feedTypeUuid,
                  searchFeedTypeUuid: searchFeedTypeUuid,
                  searchTerms: searchTerms,
                  start: start
                });

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function searchInFeed(_x4, _x5, _x6, _x7) {
        return _searchInFeed.apply(this, arguments);
      }

      return searchInFeed;
    }()
  };
};

var isRequestSuccess = function isRequestSuccess(response) {
  if (!response) {
    return false;
  }

  return (response === null || response === void 0 ? void 0 : response.status) >= 200 && (response === null || response === void 0 ? void 0 : response.status) < 300;
};

var actionsPrefix$d = "feeds";
var FETCH_FEED = "".concat(actionsPrefix$d, "/FETCH_FEED");
var FETCH_FEED_COMPLETE = "".concat(actionsPrefix$d, "/FETCH_FEED_COMPLETE");
var UPDATE_FEED_FILTERS = "".concat(actionsPrefix$d, "/UPDATE_FEED_FILTERS");

var FeedsActions = function FeedsActions(Firebase) {
  var cloudFunctions = feedsCloudFunctions(Firebase);

  var fetchFeed = function fetchFeed(feedTypeUuid, refreshMode) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var _targetFeed$feed, continueFeed, targetFeed, filters, results, _results$store;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (feedTypeUuid) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                continueFeed = refreshMode;
                targetFeed = getState().feeds.feedList[feedTypeUuid];

                if (!(targetFeed !== null && targetFeed !== void 0 && (_targetFeed$feed = targetFeed.feed) !== null && _targetFeed$feed !== void 0 && _targetFeed$feed.length)) {
                  continueFeed = false;
                }

                if (!(!(targetFeed !== null && targetFeed !== void 0 && targetFeed.isProcessing) && (!(targetFeed !== null && targetFeed !== void 0 && targetFeed.eof) && continueFeed || !continueFeed))) {
                  _context.next = 17;
                  break;
                }

                dispatch({
                  type: FETCH_FEED,
                  feedTypeUuid: feedTypeUuid,
                  clearFeed: !continueFeed
                });
                filters = getState().feeds.filters[feedTypeUuid] || {};
                _context.next = 11;
                return cloudFunctions.loadFeed(feedTypeUuid, continueFeed, filters, true);

              case 11:
                results = _context.sent;

                if (!isRequestSuccess(results)) {
                  _context.next = 16;
                  break;
                }

                dispatch({
                  type: FETCH_FEED_COMPLETE,
                  payload: results === null || results === void 0 ? void 0 : results.store,
                  feedTypeUuid: feedTypeUuid
                });
                _context.next = 17;
                break;

              case 16:
                throw results === null || results === void 0 ? void 0 : (_results$store = results.store) === null || _results$store === void 0 ? void 0 : _results$store.error;

              case 17:
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);
                dispatch({
                  type: FETCH_FEED_COMPLETE,
                  error: _context.t0,
                  message: _context.t0.message,
                  feedTypeUuid: feedTypeUuid,
                  payload: {
                    feed: [],
                    is_eof: true
                  }
                });

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 19]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  var updateFeedFilter = function updateFeedFilter(feedTypeUuid, filters) {
    var runFetch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: UPDATE_FEED_FILTERS,
                  feedTypeUuid: feedTypeUuid,
                  filters: filters
                });

                if (runFetch) {
                  dispatch(fetchFeed(feedTypeUuid));
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }();
  };

  return {
    fetchFeed: fetchFeed,
    updateFeedFilter: updateFeedFilter
  };
};

var topicCloudFunctions = function topicCloudFunctions(Firebase) {
  var functions = Firebase.functions;
  return {
    toggleTopicFollow: function () {
      var _toggleTopicFollow = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return functions.httpsCallable("backendTopicToggleFollow")(data);

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function toggleTopicFollow(_x) {
        return _toggleTopicFollow.apply(this, arguments);
      }

      return toggleTopicFollow;
    }(),
    // Accepts an array of topics to follow
    toggleFollowTopics: function () {
      var _toggleFollowTopics = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return functions.httpsCallable("backendTopicFollowTopics")(data);

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function toggleFollowTopics(_x2) {
        return _toggleFollowTopics.apply(this, arguments);
      }

      return toggleFollowTopics;
    }()
  };
};

var MAX_IN_FILTER = 10;
var DB_CONSTANTS = {
  CASE_MEDIA: "caseMediaDB",
  CASES: "casesDB",
  COMMENTS: "commentsDB",
  MESH_TERMS: "meshTermsDB",
  PUBLICATIONS: "publicationsDB",
  USERS: "usersDB",
  USER_ROLES: "userRolesDB",
  ASSIGNMENTS: "clientAssignmentDB",
  REVIEW_MESH_TERMS: "reviewMeshTermsDB",
  SAVED_CASES: "userSavedCasesDB",
  USER_DRAFTS: "userDraftsDB",
  REFERENCE_DATA: "referenceData",
  CASE_FILTERS: "caseFilters",
  COMMON: "common",
  COUNTRIES: "countries",
  COUNTRY_SUBDIVISION: "subdivisions",
  SPECIALTIES: "specialties",
  PLATFORMS: "platforms",
  CASES_V2: "casesDBv2",
  MODERATION: "moderationDB",
  VERIFICATION_TAGS: "verificationTags",
  SCHOOLS: "schools",
  CONFIGURATION: "configurationDB",
  DEFAULT_CONFIG: "DEFAULT",
  ELASTIC_CONFIG: "elasticsearchConfig",
  LABELS: "labels",
  ADMIN_USER_CASE_LOCKS: "adminUserCaseLocksDB",
  USER_ACTIVITY_RECORD: "userActivityRecordDB",
  USER_FEED: "userFeedDB",
  USER_COMMUNICATION_PREFS: "userCommunicationPrefsDB",
  USERS_PROFILE: "usersProfileDB",
  USER_NOTIFICATION: "userNotificationDB",
  USER_VOTES: "userVotesDB",
  USER_CME: "userCmeDB",
  GROUPS: "groupsDB",
  QUESTION: "questionDB",
  ANONYMOUS_AUTHORS: "anonymousAuthorsDB",
  WHATS_NEW_FLAG: "whatsNewFlagDB"
};

var REFERENCE_DOCUMENT$1 = "topics";

var topicDB = function topicDB(Firebase) {
  var getCollectionRef = Firebase.getCollectionRef;
  return {
    fetchAll: function () {
      var _fetchAll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var doc;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getCollectionRef(DB_CONSTANTS.REFERENCE_DATA).doc(REFERENCE_DOCUMENT$1).get();

              case 3:
                doc = _context.sent;

                if (!doc.exists) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", doc.data());

              case 6:
                return _context.abrupt("return", {});

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                throw new Error("There was an error fetching topics: ".concat(_context.t0.message));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      function fetchAll() {
        return _fetchAll.apply(this, arguments);
      }

      return fetchAll;
    }()
  };
};

var actionsPrefix$c = "topics";
var FETCH_TOPICS = "".concat(actionsPrefix$c, "/Fetch_TOPICS");
var FETCH_TOPICS_COMPLETE = "".concat(actionsPrefix$c, "/Fetch_TOPICS_COMPLETE");
var FOLLOW_TOPIC = "".concat(actionsPrefix$c, "/FOLLOW_TOPIC");
var FOLLOW_TOPIC_ERROR = "".concat(actionsPrefix$c, "/FOLLOW_TOPIC_ERROR");
var FOLLOW_TOPIC_COMPLETE = "".concat(actionsPrefix$c, "/FOLLOW_TOPIC_COMPLETE");

var TopicActions = function TopicActions(Firebase) {
  var cloudFunctions = topicCloudFunctions(Firebase);
  var db = topicDB(Firebase);
  return {
    fetchTopicsIfNeeded: function fetchTopicsIfNeeded() {
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
          var _getState, _getState$topics;

          var topics;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  topics = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$topics = _getState.topics) === null || _getState$topics === void 0 ? void 0 : _getState$topics.data;

                  if (_.isEmpty(topics)) {
                    dispatch(fetchTopics());
                  }

                  return _context.abrupt("return");

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();
    },
    fetchTopics: function fetchTopics() {
      return /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
          var response, topics;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  dispatch({
                    type: FETCH_TOPICS
                  });
                  _context2.prev = 1;
                  _context2.next = 4;
                  return db.fetchAll();

                case 4:
                  response = _context2.sent;

                  if (!_.isEmpty(response.all)) {
                    topics = response.all;
                    topics.sort(function (a, b) {
                      return a.displayOrder - b.displayOrder;
                    });
                    dispatch({
                      type: FETCH_TOPICS_COMPLETE,
                      data: topics
                    });
                  } else {
                    dispatch({
                      type: FETCH_TOPICS_COMPLETE,
                      error: true,
                      message: "Failed to fetch topics"
                    });
                  }

                  _context2.next = 11;
                  break;

                case 8:
                  _context2.prev = 8;
                  _context2.t0 = _context2["catch"](1);
                  dispatch({
                    type: FETCH_TOPICS_COMPLETE,
                    error: true,
                    message: _context2.t0.message
                  });

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[1, 8]]);
        }));

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }();
    },
    toggleTopicFollow: function toggleTopicFollow(topicId) {
      // optimistically update follow state before api call
      // revert state if error occurs
      return /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
          var selected, follow, newMap, response;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  selected = getState().topics.selected;
                  follow = !selected[topicId];
                  newMap = _objectSpread2(_objectSpread2({}, selected), {}, _defineProperty({}, topicId, follow));
                  dispatch({
                    type: FOLLOW_TOPIC,
                    selected: newMap
                  });
                  _context3.prev = 4;
                  _context3.next = 7;
                  return cloudFunctions.toggleTopicFollow({
                    uuid: topicId,
                    action: follow ? "follow" : "unfollow"
                  });

                case 7:
                  response = _context3.sent;

                  if (!(response.status !== 200)) {
                    _context3.next = 10;
                    break;
                  }

                  return _context3.abrupt("return", dispatch({
                    type: FOLLOW_TOPIC_ERROR,
                    message: "Failed to update follow state for topic ".concat(topicId),
                    selected: selected
                  }));

                case 10:
                  return _context3.abrupt("return", {
                    status: 200
                  });

                case 13:
                  _context3.prev = 13;
                  _context3.t0 = _context3["catch"](4);
                  return _context3.abrupt("return", dispatch({
                    type: FOLLOW_TOPIC_ERROR,
                    message: _context3.t0.message,
                    selected: selected
                  }));

                case 16:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[4, 13]]);
        }));

        return function (_x4, _x5) {
          return _ref3.apply(this, arguments);
        };
      }();
    }
  };
};

var ipInfoFunctions = function ipInfoFunctions(AppConfig) {
  return {
    checkIpCountry: function () {
      var _checkIpCountry = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                url = "".concat(BASE_URL).concat(AppConfig.ipinfo);
                _context.next = 4;
                return fetch(url, {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json"
                  }
                });

              case 4:
                response = _context.sent;

                if (!isRequestSuccess(response)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", response === null || response === void 0 ? void 0 : response.json());

              case 9:
                throw new Error("Failed to check country with error: ".concat(response.statusText));

              case 10:
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                console.log("failed to get ipstack info", _context.t0);
                throw _context.t0;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12]]);
      }));

      function checkIpCountry() {
        return _checkIpCountry.apply(this, arguments);
      }

      return checkIpCountry;
    }()
  };
};

var referenceDB = function referenceDB(Firebase) {
  var getDocRef = Firebase.getDocRef,
      getCollectionRef = Firebase.getCollectionRef;
  return {
    /**
     * Query Firebase for countries data, where each country doc has its regions nested within.
     *
     * Note: Fallback country data. Expect to use elastic search to get country/regions.
     * Use `countriesV2/countries` for app. `countries/countries` is used for admin tools.
     * Using `countriesV2/regions` is an option but fetching is too slow.
     * @returns
     */
    getAllCountriesAndRegions: function () {
      var _getAllCountriesAndRegions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var col, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getCollectionRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/countriesV2/countries")).get();

              case 3:
                col = _context.sent;
                data = [];

                if (!col.empty) {
                  col.docs.forEach(function (doc) {
                    data.push(doc.data());
                  });
                }

                return _context.abrupt("return", data);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.log("There was an error fetching countries and regions: ", _context.t0.message);
                throw new Error("There was an error fetching countries and regions");

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      function getAllCountriesAndRegions() {
        return _getAllCountriesAndRegions.apply(this, arguments);
      }

      return getAllCountriesAndRegions;
    }(),
    getProfessions: function () {
      var _getProfessions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var doc;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return getDocRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/professions")).get();

              case 3:
                doc = _context2.sent;
                return _context2.abrupt("return", doc.exists ? doc.data() : {});

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.log("There was an error fetching professions: ", _context2.t0.message);
                throw new Error("There was an error fetching professions");

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }));

      function getProfessions() {
        return _getProfessions.apply(this, arguments);
      }

      return getProfessions;
    }(),
    getProfessionSpecialties: function () {
      var _getProfessionSpecialties = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(professionUuid) {
        var collectionSnapshot, professionSpecialties;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return getCollectionRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/professions/").concat(professionUuid)).get();

              case 3:
                collectionSnapshot = _context3.sent;
                professionSpecialties = [];

                if (!collectionSnapshot.empty) {
                  collectionSnapshot.docs.forEach(function (doc) {
                    professionSpecialties.push(doc.data());
                  });
                }

                return _context3.abrupt("return", professionSpecialties);

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                console.log("There was an error fetching profession specialties: ", _context3.t0.message);
                throw new Error("There was an error fetching professions specialties");

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 9]]);
      }));

      function getProfessionSpecialties(_x) {
        return _getProfessionSpecialties.apply(this, arguments);
      }

      return getProfessionSpecialties;
    }(),
    getInterests: function () {
      var _getInterests = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var docSnapshot;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return getDocRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/interests")).get();

              case 3:
                docSnapshot = _context4.sent;
                return _context4.abrupt("return", docSnapshot.exists ? docSnapshot.data() : {});

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                console.log("There was an error fetching interests: ", _context4.t0.message);
                throw new Error("There was an error fetching interests");

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 7]]);
      }));

      function getInterests() {
        return _getInterests.apply(this, arguments);
      }

      return getInterests;
    }(),
    getPreviewFeed: function () {
      var _getPreviewFeed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref) {
        var feedTypeUuid, limit, snapshot, feed;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                feedTypeUuid = _ref.feedTypeUuid, limit = _ref.limit;
                _context5.prev = 1;
                _context5.next = 4;
                return getCollectionRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/feeds/").concat(feedTypeUuid)).limit(limit).get();

              case 4:
                snapshot = _context5.sent;
                feed = [];

                if (!snapshot.empty) {
                  snapshot.docs.forEach(function (doc) {
                    feed.push(doc.data());
                  });
                }

                return _context5.abrupt("return", feed);

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](1);
                console.log("There was an error fetching preview feed: " + feedTypeUuid, _context5.t0.message);
                throw new Error("There was an error fetching preview feed: " + feedTypeUuid);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 10]]);
      }));

      function getPreviewFeed(_x2) {
        return _getPreviewFeed.apply(this, arguments);
      }

      return getPreviewFeed;
    }(),
    getPreviewFeedMeta: function () {
      var _getPreviewFeedMeta = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _docSnapshot$data, docSnapshot;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return getDocRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/feeds")).get();

              case 3:
                docSnapshot = _context6.sent;
                return _context6.abrupt("return", docSnapshot.exists ? (_docSnapshot$data = docSnapshot.data()) === null || _docSnapshot$data === void 0 ? void 0 : _docSnapshot$data.all : {});

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                console.log("There was an error fetching preview feeds: ", _context6.t0.message);
                throw new Error("There was an error fetching preview feeds");

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 7]]);
      }));

      function getPreviewFeedMeta() {
        return _getPreviewFeedMeta.apply(this, arguments);
      }

      return getPreviewFeedMeta;
    }(),
    getGroups: function () {
      var _getGroups = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var docSnapshot;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return getDocRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/groups")).get();

              case 3:
                docSnapshot = _context7.sent;
                return _context7.abrupt("return", docSnapshot.exists ? docSnapshot.data() : {});

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                console.log("There was an error fetching groups: ", _context7.t0.message);
                throw new Error("There was an error fetching groups");

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 7]]);
      }));

      function getGroups() {
        return _getGroups.apply(this, arguments);
      }

      return getGroups;
    }()
  };
};

var actionsPrefix$b = "reference";
var FETCH_FALLBACK_LOCATIONS = "".concat(actionsPrefix$b, "/FETCH_FALLBACK_LOCATIONS");
var FETCH_FALLBACK_LOCATIONS_COMPLETE = "".concat(actionsPrefix$b, "/FETCH_FALLBACK_LOCATIONS_COMPLETE");
var FETCH_PROFESSIONS = "".concat(actionsPrefix$b, "/FETCH_PROFESSIONS");
var FETCH_PROFESSIONS_COMPLETE = "".concat(actionsPrefix$b, "/FETCH_PROFESSIONS_COMPLETE");
var FETCH_PROFESSIONS_ERROR = "".concat(actionsPrefix$b, "/FETCH_PROFESSIONS_ERROR");
var FETCH_PROFESSION_SPECIALTIES = "".concat(actionsPrefix$b, "/FETCH_PROFESSION_SPECIALTIES");
var FETCH_PROFESSION_SPECIALTIES_COMPLETE = "".concat(actionsPrefix$b, "/FETCH_PROFESSION_SPECIALTIES_COMPLETE");
var FETCH_PROFESSION_SPECIALTIES_ERROR = "".concat(actionsPrefix$b, "/FETCH_PROFESSION_SPECIALTIES_ERROR");
var FETCH_INTERESTS = "".concat(actionsPrefix$b, "/FETCH_INTERESTS");
var FETCH_INTERESTS_COMPLETE = "".concat(actionsPrefix$b, "/FETCH_INTERESTS_COMPLETE");
var FETCH_INTERESTS_ERROR = "".concat(actionsPrefix$b, "/FETCH_INTERESTS_ERROR");
var FETCH_PREVIEW_FEED = "".concat(actionsPrefix$b, "/FETCH_PREVIEW_FEED");
var FETCH_PREVIEW_FEED_COMPLETE = "".concat(actionsPrefix$b, "/FETCH_PREVIEW_FEED_COMPLETE");
var FETCH_COUNTRY_COMPLETE = "".concat(actionsPrefix$b, "/FETCH_COUNTRY_COMPLETE");
var FETCH_PREVIEW_FEED_META = "".concat(actionsPrefix$b, "/FETCH_PREVIEW_FEED_META");
var FETCH_PREVIEW_FEED_META_COMPLETE = "".concat(actionsPrefix$b, "/FETCH_PREVIEW_FEED_META_COMPLETE");

var ReferenceActions = function ReferenceActions(Firebase, AppConfig) {
  var _ipInfoFunctions = ipInfoFunctions(AppConfig),
      checkIpCountry = _ipInfoFunctions.checkIpCountry;

  var db = referenceDB(Firebase);
  /**
   * This is meant only as fallback for country data. Expect
   * to use elastic search for this.
   */

  var fetchFallbackLocationsIfNeeded = function fetchFallbackLocationsIfNeeded() {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var _getState, _getState$references, fallbackLocations, countriesAndRegions;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                fallbackLocations = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$references = _getState.references) === null || _getState$references === void 0 ? void 0 : _getState$references.fallbackLocations;

                if (!(fallbackLocations.isLoadingFallbackLocations || !isEmpty(fallbackLocations.countries) && !isEmpty(fallbackLocations.regions))) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                dispatch({
                  type: FETCH_FALLBACK_LOCATIONS
                });
                _context.next = 7;
                return db.getAllCountriesAndRegions();

              case 7:
                countriesAndRegions = _context.sent;
                dispatch({
                  type: FETCH_FALLBACK_LOCATIONS_COMPLETE,
                  payload: {
                    countriesAndRegions: countriesAndRegions
                  }
                });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                console.log("fetchFallbackLocationsIfNeeded failed: ", _context.t0.message);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  var fetchProfessionsIfNeeded = function fetchProfessionsIfNeeded() {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var _getState2, _getState2$references, result;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (isEmpty((_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : (_getState2$references = _getState2.references) === null || _getState2$references === void 0 ? void 0 : _getState2$references.professions)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                dispatch({
                  type: FETCH_PROFESSIONS
                });
                _context2.next = 6;
                return db.getProfessions();

              case 6:
                result = _context2.sent;
                dispatch({
                  type: FETCH_PROFESSIONS_COMPLETE,
                  payload: {
                    professions: result
                  }
                });
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                dispatch({
                  type: FETCH_PROFESSIONS_ERROR,
                  payload: {
                    error: _context2.t0
                  }
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();
  };

  var fetchProfessionSpecialtiesIfNeeded = function fetchProfessionSpecialtiesIfNeeded(professionUuid) {
    return /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
        var _getState3, _getState3$references, _getState3$references2, professionSpecialties;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (!((_getState3 = getState()) !== null && _getState3 !== void 0 && (_getState3$references = _getState3.references) !== null && _getState3$references !== void 0 && (_getState3$references2 = _getState3$references.professionSpecialties) !== null && _getState3$references2 !== void 0 && _getState3$references2[professionUuid] || !professionUuid)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                dispatch({
                  type: FETCH_PROFESSION_SPECIALTIES
                });
                _context3.next = 6;
                return db.getProfessionSpecialties(professionUuid);

              case 6:
                professionSpecialties = _context3.sent;
                dispatch({
                  type: FETCH_PROFESSION_SPECIALTIES_COMPLETE,
                  payload: {
                    professionUuid: professionUuid,
                    professionSpecialties: professionSpecialties
                  }
                });
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);
                dispatch({
                  type: FETCH_PROFESSION_SPECIALTIES_ERROR,
                  payload: {
                    error: _context3.t0
                  }
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 10]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }();
  };

  var fetchInterestsIfNeeded = function fetchInterestsIfNeeded() {
    return /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
        var _getState4, _getState4$references, result;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (isEmpty((_getState4 = getState()) === null || _getState4 === void 0 ? void 0 : (_getState4$references = _getState4.references) === null || _getState4$references === void 0 ? void 0 : _getState4$references.interests)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                dispatch({
                  type: FETCH_INTERESTS
                });
                _context4.next = 6;
                return db.getInterests();

              case 6:
                result = _context4.sent;
                dispatch({
                  type: FETCH_INTERESTS_COMPLETE,
                  payload: {
                    interests: result
                  }
                });
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                dispatch({
                  type: FETCH_INTERESTS_ERROR,
                  payload: {
                    error: _context4.t0
                  }
                });

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 10]]);
      }));

      return function (_x7, _x8) {
        return _ref4.apply(this, arguments);
      };
    }();
  };

  var getPreviewFeedIfNeeded = function getPreviewFeedIfNeeded(_ref5) {
    var feedTypeUuid = _ref5.feedTypeUuid,
        _ref5$limit = _ref5.limit,
        limit = _ref5$limit === void 0 ? 100 : _ref5$limit;
    return /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
        var _getState5, _getState5$references, _getState5$references2, feed;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                if (!isEmpty((_getState5 = getState()) === null || _getState5 === void 0 ? void 0 : (_getState5$references = _getState5.references) === null || _getState5$references === void 0 ? void 0 : (_getState5$references2 = _getState5$references.feeds) === null || _getState5$references2 === void 0 ? void 0 : _getState5$references2[feedTypeUuid])) {
                  _context5.next = 7;
                  break;
                }

                dispatch({
                  type: FETCH_PREVIEW_FEED,
                  payload: {
                    feedTypeUuid: feedTypeUuid
                  }
                });
                _context5.next = 5;
                return db.getPreviewFeed({
                  feedTypeUuid: feedTypeUuid,
                  limit: limit
                });

              case 5:
                feed = _context5.sent;
                dispatch({
                  type: FETCH_PREVIEW_FEED_COMPLETE,
                  payload: {
                    feed: feed,
                    feedTypeUuid: feedTypeUuid
                  }
                });

              case 7:
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);
                console.log(_context5.t0);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 9]]);
      }));

      return function (_x9, _x10) {
        return _ref6.apply(this, arguments);
      };
    }();
  };

  var getPreviewFeedMetaIfNeeded = function getPreviewFeedMetaIfNeeded() {
    return /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
        var _getState6, _getState6$references, feedsMeta;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                if (!isEmpty((_getState6 = getState()) === null || _getState6 === void 0 ? void 0 : (_getState6$references = _getState6.references) === null || _getState6$references === void 0 ? void 0 : _getState6$references.feedsMeta)) {
                  _context6.next = 7;
                  break;
                }

                dispatch({
                  type: FETCH_PREVIEW_FEED_META
                });
                _context6.next = 5;
                return db.getPreviewFeedMeta();

              case 5:
                feedsMeta = _context6.sent;
                dispatch({
                  type: FETCH_PREVIEW_FEED_META_COMPLETE,
                  payload: {
                    feedsMeta: feedsMeta
                  }
                });

              case 7:
                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](0);
                console.log(_context6.t0);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 9]]);
      }));

      return function (_x11, _x12) {
        return _ref7.apply(this, arguments);
      };
    }();
  };

  var checkCurrentCountry = function checkCurrentCountry() {
    return /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch) {
        var _response$country, response;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return checkIpCountry();

              case 3:
                response = _context7.sent;
                return _context7.abrupt("return", dispatch({
                  type: FETCH_COUNTRY_COMPLETE,
                  payload: {
                    country: response === null || response === void 0 ? void 0 : (_response$country = response.country) === null || _response$country === void 0 ? void 0 : _response$country.toUpperCase()
                  }
                }));

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", dispatch({
                  type: FETCH_COUNTRY_COMPLETE,
                  payload: {
                    country: "US",
                    error: true,
                    message: _context7.t0.message
                  }
                }));

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 7]]);
      }));

      return function (_x13) {
        return _ref8.apply(this, arguments);
      };
    }();
  };

  var getGroupsInfoIfNeeded = function getGroupsInfoIfNeeded() {
    return /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
        var _getState7, _getState7$references, groups;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                if (!isEmpty((_getState7 = getState()) === null || _getState7 === void 0 ? void 0 : (_getState7$references = _getState7.references) === null || _getState7$references === void 0 ? void 0 : _getState7$references.groups)) {
                  _context8.next = 7;
                  break;
                }

                dispatch({
                  type: FETCH_GROUPS
                });
                _context8.next = 5;
                return db.getGroups();

              case 5:
                groups = _context8.sent;
                dispatch({
                  type: FETCH_GROUPS_COMPLETE,
                  payload: {
                    groups: groups
                  }
                });

              case 7:
                _context8.next = 12;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](0);
                console.log(_context8.t0);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 9]]);
      }));

      return function (_x14, _x15) {
        return _ref9.apply(this, arguments);
      };
    }();
  };

  return {
    fetchFallbackLocationsIfNeeded: fetchFallbackLocationsIfNeeded,
    fetchProfessionsIfNeeded: fetchProfessionsIfNeeded,
    fetchProfessionSpecialtiesIfNeeded: fetchProfessionSpecialtiesIfNeeded,
    fetchInterestsIfNeeded: fetchInterestsIfNeeded,
    getPreviewFeedIfNeeded: getPreviewFeedIfNeeded,
    getPreviewFeedMetaIfNeeded: getPreviewFeedMetaIfNeeded,
    checkCurrentCountry: checkCurrentCountry,
    getGroupsInfoIfNeeded: getGroupsInfoIfNeeded
  };
};

/** @format */
var groupsCloudFunctions = function groupsCloudFunctions(Firebase) {
  var functions = Firebase.functions;
  return {
    groupModifyMembersCall: function () {
      var _groupModifyMembersCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(action, groupUuid, usersUuid) {
        var callableFn, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                callableFn = functions.httpsCallable("backendGroupsModifyMembers");
                _context.next = 3;
                return callableFn({
                  action: action,
                  groupUuid: groupUuid,
                  usersUuid: usersUuid
                });

              case 3:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function groupModifyMembersCall(_x, _x2, _x3) {
        return _groupModifyMembersCall.apply(this, arguments);
      }

      return groupModifyMembersCall;
    }(),
    createGroupCall: function () {
      var _createGroupCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref) {
        var groupName, groupDescription, isPublicGroup, creatorUuid, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                groupName = _ref.groupName, groupDescription = _ref.groupDescription, isPublicGroup = _ref.isPublicGroup, creatorUuid = _ref.creatorUuid;
                _context2.next = 3;
                return functions.httpsCallable("backendGroupsCreate")({
                  groupName: groupName,
                  groupDescription: groupDescription,
                  isPublicGroup: isPublicGroup,
                  creatorUuid: creatorUuid
                });

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function createGroupCall(_x4) {
        return _createGroupCall.apply(this, arguments);
      }

      return createGroupCall;
    }(),
    inviteMembersToGroupCall: function () {
      var _inviteMembersToGroupCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref2) {
        var groupUuid, inviteeUuids, result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                groupUuid = _ref2.groupUuid, inviteeUuids = _ref2.inviteeUuids;
                _context3.next = 3;
                return functions.httpsCallable("backendGroupsInviteMembers")({
                  groupUuid: groupUuid,
                  usersUuid: inviteeUuids
                });

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", result.data);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function inviteMembersToGroupCall(_x5) {
        return _inviteMembersToGroupCall.apply(this, arguments);
      }

      return inviteMembersToGroupCall;
    }()
  };
};

var groupsDB = function groupsDB(Firebase) {
  var firestore = Firebase.firestore;
  return {
    getGroupsByIds: function () {
      var _getGroupsByIds = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(groupIds) {
        var _ret;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                return _context2.delegateYield( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var batches, groups, batch;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          batches = [];
                          groups = {};

                          while (!isEmpty(groupIds)) {
                            batch = groupIds.splice(0, MAX_IN_FILTER);
                            batches.push(firestore.collection(DB_CONSTANTS.GROUPS).where("groupUuid", "in", batch).get().then(function (results) {
                              return results.docs.map(function (doc) {
                                return groups[doc.id] = doc.data();
                              });
                            }));
                          }

                          _context.next = 5;
                          return Promise.all(batches);

                        case 5:
                          return _context.abrupt("return", {
                            v: groups
                          });

                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })(), "t0", 2);

              case 2:
                _ret = _context2.t0;

                if (!(_typeof(_ret) === "object")) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", _ret.v);

              case 5:
                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t1 = _context2["catch"](0);
                console.log("There was an error fetching groups: ", _context2.t1.message);
                throw new Error("There was an error fetching groups");

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }));

      function getGroupsByIds(_x) {
        return _getGroupsByIds.apply(this, arguments);
      }

      return getGroupsByIds;
    }(),
    listenToGroups: function () {
      var _listenToGroups = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(callback) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return firestore.collection(DB_CONSTANTS.GROUPS).onSnapshot(function (colSnapShot) {
                  var groups = {};

                  if (!colSnapShot.empty) {
                    colSnapShot.docs.forEach(function (doc) {
                      return groups[doc.id] = doc.data();
                    });
                  }

                  callback(groups);
                }, function (onObservableNextOrError) {
                  console.log("listenToGroups.onObservableNextOrError: ", onObservableNextOrError);
                });

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function listenToGroups(_x2) {
        return _listenToGroups.apply(this, arguments);
      }

      return listenToGroups;
    }(),
    getMembersOfGroup: function () {
      var _getMembersOfGroup = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(groupUuid) {
        var snapshot, members;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return firestore.collection("".concat(DB_CONSTANTS.GROUPS, "/").concat(groupUuid, "/members")).get();

              case 3:
                snapshot = _context4.sent;
                members = [];

                if (!snapshot.empty) {
                  snapshot.docs.forEach(function (doc) {
                    return members.push(doc.data());
                  });
                }

                return _context4.abrupt("return", members);

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);
                console.log("There was an error fetching group members: ", _context4.t0.message);
                throw new Error("There was an error fetching group members");

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 9]]);
      }));

      function getMembersOfGroup(_x3) {
        return _getMembersOfGroup.apply(this, arguments);
      }

      return getMembersOfGroup;
    }()
  };
};

var actionsPrefix$a = "groups";
var SELECT_GROUP = "".concat(actionsPrefix$a, "/SELECT_GROUP");
var CREATE_GROUP = "".concat(actionsPrefix$a, "/CREATE_GROUP");
var CREATE_GROUP_COMPLETE = "".concat(actionsPrefix$a, "/CREATE_GROUP_COMPLETE");
var SEND_INVITE = "".concat(actionsPrefix$a, "/SEND_INVITE");
var SEND_INVITE_COMPLETE = "".concat(actionsPrefix$a, "/SEND_INVITE_COMPLETE");
var LEAVE_GROUP = "".concat(actionsPrefix$a, "/LEAVE_GROUP");
var LEAVE_GROUP_COMPLETE = "".concat(actionsPrefix$a, "/LEAVE_GROUP_COMPLETE");
var GROUPS_LISTENER_ON = "".concat(actionsPrefix$a, "/GROUPS_LISTENER_ON");
var GROUPS_LISTENER_OFF = "".concat(actionsPrefix$a, "/GROUPS_LISTENER_OFF");
var FETCH_GROUPS$1 = "".concat(actionsPrefix$a, "/FETCH_GROUPS");
var FETCH_GROUPS_COMPLETE$1 = "".concat(actionsPrefix$a, "/FETCH_GROUPS_COMPLETE");
var FETCH_GROUP_MEMBERS = "".concat(actionsPrefix$a, "/FETCH_GROUP_MEMBERS");
var FETCH_GROUP_MEMBERS_COMPLETE = "".concat(actionsPrefix$a, "/FETCH_GROUP_MEMBERS_COMPLETE");
var CLEAR_ERROR = "".concat(actionsPrefix$a, "/CLEAR_ERROR");

var GroupsActions = function GroupsActions(Firebase) {
  var cloudFunctions = groupsCloudFunctions(Firebase);
  var db = groupsDB(Firebase);

  var addMembers = function addMembers(groupUuid, usersUuid) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!groupUuid || usersUuid.length === 0)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return cloudFunctions.groupModifyMembersCall("add_members", groupUuid, usersUuid);

            case 4:
              result = _context.sent;

              if (!isRequestSuccess(result)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", result);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  var removeMembers = function removeMembers(groupUuid, usersUuid) {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!groupUuid || usersUuid.length === 0)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.prev = 2;
                dispatch({
                  type: LEAVE_GROUP
                });
                _context2.next = 6;
                return cloudFunctions.groupModifyMembersCall("remove_members", groupUuid, usersUuid);

              case 6:
                result = _context2.sent;

                if (isRequestSuccess(result)) {
                  _context2.next = 9;
                  break;
                }

                throw new Error("failed to remove from group");

              case 9:
                return _context2.abrupt("return", dispatch({
                  type: LEAVE_GROUP_COMPLETE
                }));

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](2);
                return _context2.abrupt("return", dispatch({
                  type: LEAVE_GROUP_COMPLETE,
                  error: true,
                  message: _context2.t0.message
                }));

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 12]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
  };

  var selectGroup = function selectGroup(group) {
    return /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (group) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                dispatch({
                  type: SELECT_GROUP,
                  payload: {
                    group: group
                  }
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
  };

  var createGroup = function createGroup(_ref4) {
    var groupName = _ref4.groupName,
        groupDescription = _ref4.groupDescription,
        isPublicGroup = _ref4.isPublicGroup;
    return /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
        var _getState$user, response, _response$store, errorText;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch({
                  type: CREATE_GROUP,
                  payload: {
                    groupName: groupName,
                    groupDescription: groupDescription,
                    isPublicGroup: isPublicGroup
                  }
                });
                _context4.prev = 1;
                _context4.next = 4;
                return cloudFunctions.createGroupCall({
                  groupName: groupName,
                  groupDescription: groupDescription,
                  isPublicGroup: isPublicGroup,
                  creatorUuid: (_getState$user = getState().user) === null || _getState$user === void 0 ? void 0 : _getState$user.userUuid
                });

              case 4:
                response = _context4.sent;

                if (!isRequestSuccess(response)) {
                  _context4.next = 10;
                  break;
                }

                dispatch(selectGroup(response.store));
                return _context4.abrupt("return", dispatch({
                  type: CREATE_GROUP_COMPLETE,
                  payload: {
                    groupUuid: response.store.groupUuid
                  }
                }));

              case 10:
                errorText = "Failed to create group due to request failure";

                if ((_response$store = response.store) !== null && _response$store !== void 0 && _response$store.msg) {
                  errorText = response.store.msg;
                }

                return _context4.abrupt("return", dispatch({
                  type: CREATE_GROUP_COMPLETE,
                  error: true,
                  message: errorText,
                  payload: {
                    response: response
                  }
                }));

              case 13:
                _context4.next = 18;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](1);
                return _context4.abrupt("return", dispatch({
                  type: CREATE_GROUP_COMPLETE,
                  error: true,
                  message: _context4.t0.message
                }));

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 15]]);
      }));

      return function (_x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }();
  };

  var inviteMembers = function inviteMembers(_ref6) {
    var groupUuid = _ref6.groupUuid,
        inviteeUuids = _ref6.inviteeUuids;
    return /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch) {
        var response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dispatch({
                  type: SEND_INVITE,
                  payload: {
                    groupUuid: groupUuid,
                    inviteeUuids: inviteeUuids
                  }
                });
                _context5.prev = 1;
                _context5.next = 4;
                return cloudFunctions.inviteMembersToGroupCall({
                  groupUuid: groupUuid,
                  inviteeUuids: inviteeUuids
                });

              case 4:
                response = _context5.sent;

                if (!isRequestSuccess(response)) {
                  _context5.next = 9;
                  break;
                }

                return _context5.abrupt("return", dispatch({
                  type: SEND_INVITE_COMPLETE,
                  payload: {
                    groupUuid: groupUuid,
                    inviteeUuids: inviteeUuids
                  }
                }));

              case 9:
                throw new Error("Failed to create group due to request failure");

              case 10:
                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](1);
                return _context5.abrupt("return", dispatch({
                  type: SEND_INVITE_COMPLETE,
                  payload: {
                    groupUuid: groupUuid,
                    inviteeUuids: inviteeUuids
                  },
                  error: true,
                  message: _context5.t0.message
                }));

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 12]]);
      }));

      return function (_x5) {
        return _ref7.apply(this, arguments);
      };
    }();
  };

  var fetchGroupsByIds = function fetchGroupsByIds(groupIds) {
    return /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
        var _getState$groups, existingGroups, filtered, groups;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                existingGroups = (_getState$groups = getState().groups) === null || _getState$groups === void 0 ? void 0 : _getState$groups.data;
                filtered = groupIds === null || groupIds === void 0 ? void 0 : groupIds.filter(function (id) {
                  return !existingGroups[id];
                });

                if (!isEmpty(filtered)) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return", dispatch({
                  type: FETCH_GROUPS_COMPLETE$1,
                  message: "empty request"
                }));

              case 5:
                dispatch({
                  type: FETCH_GROUPS$1,
                  payload: {
                    filtered: filtered
                  }
                });
                _context6.next = 8;
                return db.getGroupsByIds(filtered);

              case 8:
                groups = _context6.sent;
                return _context6.abrupt("return", dispatch({
                  type: FETCH_GROUPS_COMPLETE$1,
                  payload: {
                    groups: groups
                  }
                }));

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", dispatch({
                  type: FETCH_GROUPS_COMPLETE$1,
                  error: true,
                  message: _context6.t0.message
                }));

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 12]]);
      }));

      return function (_x6, _x7) {
        return _ref8.apply(this, arguments);
      };
    }();
  };

  var toggleGroupsListener = function toggleGroupsListener(on) {
    return /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
        var listener;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!on) {
                  _context7.next = 8;
                  break;
                }

                if (getState().groups.listener) {
                  _context7.next = 6;
                  break;
                }

                _context7.next = 4;
                return db.listenToGroups(function (groups) {
                  dispatch({
                    type: FETCH_GROUPS_COMPLETE$1,
                    payload: {
                      groups: groups
                    }
                  });
                });

              case 4:
                listener = _context7.sent;
                dispatch({
                  type: GROUPS_LISTENER_ON,
                  payload: {
                    listener: listener
                  }
                });

              case 6:
                _context7.next = 9;
                break;

              case 8:
                if (getState().groups.listener) {
                  getState().groups.listener();
                  dispatch({
                    type: GROUPS_LISTENER_OFF
                  });
                }

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x8, _x9) {
        return _ref9.apply(this, arguments);
      };
    }();
  };

  var fetchGroupMembers = function fetchGroupMembers(groupUuid) {
    return /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch) {
        var members;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                dispatch({
                  type: FETCH_GROUP_MEMBERS,
                  payload: {
                    groupUuid: groupUuid
                  }
                });
                _context8.next = 4;
                return db.getMembersOfGroup(groupUuid);

              case 4:
                members = _context8.sent;
                return _context8.abrupt("return", dispatch({
                  type: FETCH_GROUP_MEMBERS_COMPLETE,
                  payload: {
                    members: members,
                    groupUuid: groupUuid
                  }
                }));

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](0);
                console.log("failed to fetch group members ", _context8.t0.message);
                return _context8.abrupt("return", dispatch({
                  type: FETCH_GROUP_MEMBERS_COMPLETE,
                  payload: {
                    groupUuid: groupUuid
                  },
                  error: true,
                  message: _context8.t0.message
                }));

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 8]]);
      }));

      return function (_x10) {
        return _ref10.apply(this, arguments);
      };
    }();
  };

  var clearError = function clearError() {
    return /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(dispatch) {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                return _context9.abrupt("return", dispatch({
                  type: CLEAR_ERROR
                }));

              case 4:
                _context9.prev = 4;
                _context9.t0 = _context9["catch"](0);
                console.log("failed to clear error ", _context9.t0.message);

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[0, 4]]);
      }));

      return function (_x11) {
        return _ref11.apply(this, arguments);
      };
    }();
  };

  return {
    addMembers: addMembers,
    removeMembers: removeMembers,
    selectGroup: selectGroup,
    createGroup: createGroup,
    inviteMembers: inviteMembers,
    fetchGroupsByIds: fetchGroupsByIds,
    toggleGroupsListener: toggleGroupsListener,
    fetchGroupMembers: fetchGroupMembers,
    clearError: clearError
  };
};

/** @format */
var caseCloudFunctions = function caseCloudFunctions(Firebase) {
  var functions = Firebase.functions;
  return {
    translateCase: function () {
      var _translateCase = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(caseUuid, targetLanguage) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return functions.httpsCallable("backendCaseTranslate")({
                  case_uuid: caseUuid,
                  target_language: targetLanguage
                });

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function translateCase(_x, _x2) {
        return _translateCase.apply(this, arguments);
      }

      return translateCase;
    }()
  };
};

var SUPPORTED_LANGUAGES = ["en", "es", "pt"];

/**
 * @param {Array<{language: string, text: string}>} translations
 * @param {string} language
 */

var hasTranslation = function hasTranslation(translations, language) {
  return findTranslation(translations, language) !== undefined;
};
/**
 * @param {Array<{language: string, text: string}>} translations
 * @param {string} language
 */

var findTranslation = function findTranslation(translations, language) {
  return (translations !== null && translations !== void 0 ? translations : []).find(function (translation) {
    return areEqual(translation.language, language);
  });
};
/**
 * @param {string} languageA
 * @param {string} languageB
 */

var areEqual = function areEqual(languageA, languageB) {
  var languageCodeA = getLanguageCode(languageA);
  var languageCodeB = getLanguageCode(languageB);
  return languageCodeA.toLowerCase() === languageCodeB.toLowerCase();
};
/**
 * @param {string} language The language code or tag. i.e. en-US, en-GB, en
 * @returns the language code. i.e. en-US returns en
 */

var getLanguageCode = function getLanguageCode(language) {
  if (language.indexOf("-") !== -1) {
    return language.split("-")[0];
  }

  if (language.indexOf("_") !== -1) {
    language = language.split("_")[0];
  }

  return language;
};
/**
 * @param {string} language The language code or tag. i.e. en-US, en-GB, en
 */

var isSupportedLanguage = function isSupportedLanguage(language) {
  return SUPPORTED_LANGUAGES.some(function (l) {
    return areEqual(language, l);
  });
};

var TranslationUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  hasTranslation: hasTranslation,
  findTranslation: findTranslation,
  areEqual: areEqual,
  getLanguageCode: getLanguageCode,
  isSupportedLanguage: isSupportedLanguage
});

/** @format */
var selectCurrentLanguageCode = function selectCurrentLanguageCode(state) {
  return getLanguageCode(state.localization.currentLanguage);
};

var LocalizationSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectCurrentLanguageCode: selectCurrentLanguageCode
});

var SPONSORED_CASE_PREFIX = "SC_";
var CASE_STATE = {
  REJECTED: "REJECTED",
  REPORTED: "REPORTED",
  DELETED: "DELETED",
  DRAFT: "DRAFT",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  FLAGGED: "FLAGGED",
  EDIT_SUGGESTED: "EDIT_SUGGESTED",
  APPROVED: "APPROVED",
  PENDING_NLP: "PENDING_NLP",
  PENDING_TAGGING: "PENDING_TAGGING",
  FLAGGED_TAGGER: "FLAGGED_TAGGER",
  SC_DRAFT: "SC_DRAFT",
  SC_REVIEW: "SC_REVIEW",
  SC_APPROVED: "SC_APPROVED",
  SC_ARCHIVED: "SC_ARCHIVED"
};

var CaseState = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SPONSORED_CASE_PREFIX: SPONSORED_CASE_PREFIX,
  CASE_STATE: CASE_STATE
});

/** @format */
var CASE_TYPE = {
  STATIC: "static",
  QUIZ: "quiz",
  QUIZ_SERIES: "quiz_series",
  CLINICAL_MOMENTS: "clinical_moments",
  CME: "cme"
};
var PREVIEW_FEED_TYPE = {
  TRENDING_CASES: "trendingCases",
  NEW_CASES: "newCases"
};
var INTERACTIVE_CASE_TYPES = [CASE_TYPE.QUIZ, CASE_TYPE.QUIZ_SERIES, CASE_TYPE.CLINICAL_MOMENTS, CASE_TYPE.CME];
var QUESTION_CASE_TYPES = [CASE_TYPE.QUIZ, CASE_TYPE.QUIZ_SERIES];
var CASE_CLASSIFICATIONS = {
  MEDICAL: "medical",
  NON_MEDICAL: "nonmedical"
};
var CASE_CLASSIFICATIONS_NAME = {
  MEDICAL: "Clinical case",
  NONMEDICAL: "Post"
};

var CaseType = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CASE_TYPE: CASE_TYPE,
  PREVIEW_FEED_TYPE: PREVIEW_FEED_TYPE,
  INTERACTIVE_CASE_TYPES: INTERACTIVE_CASE_TYPES,
  QUESTION_CASE_TYPES: QUESTION_CASE_TYPES,
  CASE_CLASSIFICATIONS: CASE_CLASSIFICATIONS,
  CASE_CLASSIFICATIONS_NAME: CASE_CLASSIFICATIONS_NAME
});

/**
 * Return true if a sponsored case.
 *
 * @param {Object} caseData
 * @returns {boolean}
 */

var isSponsoredCase = function isSponsoredCase(caseContent) {
  var _caseContent$isSponso;

  return (_caseContent$isSponso = caseContent === null || caseContent === void 0 ? void 0 : caseContent.isSponsored) !== null && _caseContent$isSponso !== void 0 ? _caseContent$isSponso : false;
};
/**
 * Return true if a static case.
 *
 * Note: We don't have a flag for this property, so we check
 * if case state includes the static prefix.
 * @param {String} caseState
 * @returns {boolean}
 */

var isStaticCase = function isStaticCase(caseState) {
  return caseState === null || caseState === void 0 ? void 0 : caseState.startsWith(SPONSORED_CASE_PREFIX);
};
var normalizeTranslations = function normalizeTranslations(translations) {
  return Array.isArray(translations) ? translations : Object.values(translations !== null && translations !== void 0 ? translations : {});
};
var isTranslationEnabled = function isTranslationEnabled(caseContent, currentLanguageCode) {
  var isStaticCase = caseContent.caseType === CASE_TYPE.STATIC;
  var isSponsored = isSponsoredCase(caseContent);
  return !isSponsored && isStaticCase && !areEqual(currentLanguageCode, caseContent.language || "en-US") && isSupportedLanguage(currentLanguageCode);
};
var isUserGeneratedCase = function isUserGeneratedCase(caseContent) {
  if (!caseContent) return false;
  return caseContent.caseState === CASE_STATE.APPROVED;
};
var isNonMedicalContent = function isNonMedicalContent(caseContent) {
  return (caseContent === null || caseContent === void 0 ? void 0 : caseContent.caseClassification) === CASE_CLASSIFICATIONS.NON_MEDICAL;
};

var CaseUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isSponsoredCase: isSponsoredCase,
  isStaticCase: isStaticCase,
  normalizeTranslations: normalizeTranslations,
  isTranslationEnabled: isTranslationEnabled,
  isUserGeneratedCase: isUserGeneratedCase,
  isNonMedicalContent: isNonMedicalContent
});

var actionsPrefix$9 = "case-list";
var TRANSLATE_CASE = "".concat(actionsPrefix$9, "/TRANSLATE_CASE");
var TRANSLATE_CASE_COMPLETE = "".concat(actionsPrefix$9, "/TRANSLATE_CASE_COMPLETE");
var VIEW_ORIGINAL_CASE_TRANSLATION = "".concat(actionsPrefix$9, "/VIEW_ORIGINAL_CASE_TRANSLATION");

var CaseActions = function CaseActions(Firebase) {
  var cloudFunctions = caseCloudFunctions(Firebase);

  var viewTranslatedCase = function viewTranslatedCase(caseObj) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var currentLanguageCode, caseTranslations, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: TRANSLATE_CASE,
                  caseUuid: caseObj.caseUuid
                });
                currentLanguageCode = selectCurrentLanguageCode(getState());
                caseTranslations = normalizeTranslations(caseObj.translations);

                if (!hasTranslation(caseTranslations, currentLanguageCode)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", dispatch(viewTranslatedCaseSuccess(caseObj.caseUuid)));

              case 5:
                _context.prev = 5;
                _context.next = 8;
                return cloudFunctions.translateCase(caseObj.caseUuid, currentLanguageCode);

              case 8:
                response = _context.sent;

                if (!isRequestSuccess(response)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", dispatch(viewTranslatedCaseSuccess(caseObj.caseUuid)));

              case 13:
                throw new Error("failed to sync translation due to server error");

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](5);
                return _context.abrupt("return", dispatch(viewTranslatedCaseError(caseObj.caseUuid, _context.t0.message)));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 16]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  var viewTranslatedCaseSuccess = function viewTranslatedCaseSuccess(caseUuid) {
    return {
      type: TRANSLATE_CASE_COMPLETE,
      caseUuid: caseUuid,
      error: false,
      message: undefined
    };
  };

  var viewTranslatedCaseError = function viewTranslatedCaseError(caseUuid, errorMessage) {
    return {
      type: TRANSLATE_CASE_COMPLETE,
      caseUuid: caseUuid,
      error: true,
      message: errorMessage
    };
  };

  var viewOriginalCaseTranslation = function viewOriginalCaseTranslation(caseUuid) {
    return {
      type: VIEW_ORIGINAL_CASE_TRANSLATION,
      caseUuid: caseUuid
    };
  };

  return {
    viewTranslatedCase: viewTranslatedCase,
    viewOriginalCaseTranslation: viewOriginalCaseTranslation
  };
};

/** @format */
var commentCloudFunctions = function commentCloudFunctions(Firebase) {
  var functions = Firebase.functions;
  return {
    translateComment: function () {
      var _translateComment = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(commentId, targetLanguage) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return functions.httpsCallable("backendCommentTranslate")({
                  comment_uuid: commentId,
                  target_language: targetLanguage
                });

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function translateComment(_x, _x2) {
        return _translateComment.apply(this, arguments);
      }

      return translateComment;
    }(),
    markAcceptedAnswerCall: function () {
      var _markAcceptedAnswerCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref) {
        var commentUuid, isAnswer, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commentUuid = _ref.commentUuid, isAnswer = _ref.isAnswer;
                _context2.next = 3;
                return functions.httpsCallable("backendCommentAcceptAnswer")({
                  comment_uuid: commentUuid,
                  is_accepted_answer: isAnswer
                });

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function markAcceptedAnswerCall(_x3) {
        return _markAcceptedAnswerCall.apply(this, arguments);
      }

      return markAcceptedAnswerCall;
    }()
  };
};

var selectCaseData = function selectCaseData(state, caseUuid) {
  var _state$case$cases$cas;

  return (_state$case$cases$cas = state["case"].cases[caseUuid]) === null || _state$case$cases$cas === void 0 ? void 0 : _state$case$cases$cas.data;
};
var selectIsLoadingTranslation$1 = function selectIsLoadingTranslation(state, caseUuid) {
  var _state$case$translati, _state$case$translati2, _state$case$translati3;

  return (_state$case$translati = (_state$case$translati2 = state["case"].translations) === null || _state$case$translati2 === void 0 ? void 0 : (_state$case$translati3 = _state$case$translati2[caseUuid]) === null || _state$case$translati3 === void 0 ? void 0 : _state$case$translati3.isLoading) !== null && _state$case$translati !== void 0 ? _state$case$translati : false;
};
var selectIsViewingTranslation$1 = function selectIsViewingTranslation(state, caseUuid) {
  var _state$case$translati4, _state$case$translati5, _state$case$translati6;

  return (_state$case$translati4 = (_state$case$translati5 = state["case"].translations) === null || _state$case$translati5 === void 0 ? void 0 : (_state$case$translati6 = _state$case$translati5[caseUuid]) === null || _state$case$translati6 === void 0 ? void 0 : _state$case$translati6.isTranslated) !== null && _state$case$translati4 !== void 0 ? _state$case$translati4 : false;
};
var selectIsTranslationEnabled$1 = function selectIsTranslationEnabled(state, caseUuid) {
  var _selectCaseData;

  var caseData = (_selectCaseData = selectCaseData(state, caseUuid)) !== null && _selectCaseData !== void 0 ? _selectCaseData : {};
  var currentLanguageCode = selectCurrentLanguageCode(state);
  return isTranslationEnabled(caseData, currentLanguageCode);
};
var selectCaseTranslation = function selectCaseTranslation(state, caseUuid) {
  var _selectCaseData2;

  var caseData = (_selectCaseData2 = selectCaseData(state, caseUuid)) !== null && _selectCaseData2 !== void 0 ? _selectCaseData2 : {};
  var isTranslationEnabled = selectIsTranslationEnabled$1(state, caseUuid);
  var isViewingTranslation = selectIsViewingTranslation$1(state, caseUuid);

  if (isTranslationEnabled && isViewingTranslation) {
    var currentLanguageCode = selectCurrentLanguageCode(state);
    var caseTranslations = normalizeTranslations(caseData.translations);
    var translation = findTranslation(caseTranslations, currentLanguageCode);

    if (translation) {
      return {
        title: translation.title,
        caption: translation.caption
      };
    }
  }

  return {
    title: caseData.title,
    caption: caseData.caption
  };
};
var selectCaseUpdatesTranslation = function selectCaseUpdatesTranslation(state, caseUuid, contentUuid) {
  var _caseData$contentItem, _caseContent$updates2;

  var caseData = selectCaseData(state, caseUuid);
  var isTranslationEnabled = selectIsTranslationEnabled$1(state, caseUuid);
  var isViewingTranslation = selectIsViewingTranslation$1(state, caseUuid);
  var caseContent = ((_caseData$contentItem = caseData === null || caseData === void 0 ? void 0 : caseData.contentItems) !== null && _caseData$contentItem !== void 0 ? _caseData$contentItem : []).find(function (c) {
    return c.contentUuid === contentUuid;
  });

  if (isTranslationEnabled && isViewingTranslation) {
    var _caseContent$updates;

    var currentLanguageCode = selectCurrentLanguageCode(state);
    var translations = ((_caseContent$updates = caseContent === null || caseContent === void 0 ? void 0 : caseContent.updates) !== null && _caseContent$updates !== void 0 ? _caseContent$updates : []).map(function (update) {
      var updateTranslations = normalizeTranslations(update.translations);
      var translation = findTranslation(updateTranslations, currentLanguageCode);
      return translation ? _objectSpread2(_objectSpread2({}, update), {}, {
        text: translation.text
      }) : update;
    });
    return translations;
  }

  return (_caseContent$updates2 = caseContent === null || caseContent === void 0 ? void 0 : caseContent.updates) !== null && _caseContent$updates2 !== void 0 ? _caseContent$updates2 : [];
};

var CaseSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectCaseData: selectCaseData,
  selectIsLoadingTranslation: selectIsLoadingTranslation$1,
  selectIsViewingTranslation: selectIsViewingTranslation$1,
  selectIsTranslationEnabled: selectIsTranslationEnabled$1,
  selectCaseTranslation: selectCaseTranslation,
  selectCaseUpdatesTranslation: selectCaseUpdatesTranslation
});

/** @format */
var selectIsLoadingTranslation = function selectIsLoadingTranslation(state, commentUuid) {
  var _state$comment$transl, _state$comment$transl2, _state$comment$transl3;

  return (_state$comment$transl = (_state$comment$transl2 = state.comment.translations) === null || _state$comment$transl2 === void 0 ? void 0 : (_state$comment$transl3 = _state$comment$transl2[commentUuid]) === null || _state$comment$transl3 === void 0 ? void 0 : _state$comment$transl3.isLoading) !== null && _state$comment$transl !== void 0 ? _state$comment$transl : false;
};
var selectIsViewingTranslation = function selectIsViewingTranslation(state, commentUuid) {
  var _state$comment$transl4, _state$comment$transl5, _state$comment$transl6;

  return (_state$comment$transl4 = (_state$comment$transl5 = state.comment.translations) === null || _state$comment$transl5 === void 0 ? void 0 : (_state$comment$transl6 = _state$comment$transl5[commentUuid]) === null || _state$comment$transl6 === void 0 ? void 0 : _state$comment$transl6.isTranslated) !== null && _state$comment$transl4 !== void 0 ? _state$comment$transl4 : false;
};
var selectIsTranslationEnabled = function selectIsTranslationEnabled(state, commentUuid, caseUuid) {
  var _selectCaseData, _comment$language;

  var caseData = (_selectCaseData = selectCaseData(state, caseUuid)) !== null && _selectCaseData !== void 0 ? _selectCaseData : {};
  var isStaticCase = caseData.caseType === CASE_TYPE.STATIC;
  var isSponsored = isSponsoredCase(caseData);

  if (isSponsored || !isStaticCase) {
    return false;
  }

  var comment = selectCaseComment(state, commentUuid, caseUuid);
  var currentLanguageCode = selectCurrentLanguageCode(state);
  return !areEqual((_comment$language = comment === null || comment === void 0 ? void 0 : comment.language) !== null && _comment$language !== void 0 ? _comment$language : "en-US", currentLanguageCode) && isSupportedLanguage(currentLanguageCode);
};
var selectCommentTranslation = function selectCommentTranslation(state, commentUuid, caseUuid) {
  var _comment$text;

  var comment = selectCaseComment(state, commentUuid, caseUuid);
  var isTranslationEnabled = selectIsTranslationEnabled(state, commentUuid, caseUuid);
  var isViewingTranslation = selectIsViewingTranslation(state, commentUuid);

  if (isTranslationEnabled && isViewingTranslation) {
    var _comment$translations;

    var currentLanguageCode = selectCurrentLanguageCode(state);
    var translation = findTranslation((_comment$translations = comment === null || comment === void 0 ? void 0 : comment.translations) !== null && _comment$translations !== void 0 ? _comment$translations : [], currentLanguageCode);

    if (translation) {
      return translation.text;
    }
  }

  return (_comment$text = comment === null || comment === void 0 ? void 0 : comment.text) !== null && _comment$text !== void 0 ? _comment$text : "";
};
var selectCaseComment = function selectCaseComment(state, commentUuid, caseUuid) {
  var _state$comment$caseCo, _state$comment$caseCo2;

  var comments = (_state$comment$caseCo = (_state$comment$caseCo2 = state.comment.caseComments[caseUuid]) === null || _state$comment$caseCo2 === void 0 ? void 0 : _state$comment$caseCo2.originalTree) !== null && _state$comment$caseCo !== void 0 ? _state$comment$caseCo : [];

  for (var i = 0; i < comments.length; i++) {
    var _comment$children;

    var comment = comments[i];

    if (comment.commentUuid === commentUuid) {
      return comment;
    }

    var childComment = (_comment$children = comment.children) === null || _comment$children === void 0 ? void 0 : _comment$children[commentUuid];

    if (childComment) {
      return childComment;
    }
  }
};

var CommentSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectIsLoadingTranslation: selectIsLoadingTranslation,
  selectIsViewingTranslation: selectIsViewingTranslation,
  selectIsTranslationEnabled: selectIsTranslationEnabled,
  selectCommentTranslation: selectCommentTranslation,
  selectCaseComment: selectCaseComment
});

var actionsPrefix$8 = "comments";
var TRANSLATE_COMMENT = "".concat(actionsPrefix$8, "/TRANSLATE_COMMENT");
var TRANSLATE_COMMENT_COMPLETE = "".concat(actionsPrefix$8, "/TRANSLATE_COMMENT_COMPLETE");
var VIEW_ORIGINAL_COMMENT = "".concat(actionsPrefix$8, "/VIEW_ORIGINAL_COMMENT");
var MARK_ACCEPTED_ANSWER = "".concat(actionsPrefix$8, "/MARK_ACCEPTED_ANSWER");
var MARK_ACCEPTED_ANSWER_COMPLETE = "".concat(actionsPrefix$8, "/MARK_ACCEPTED_ANSWER_COMPLETE");

var CommentActions = function CommentActions(Firebase) {
  var cloudFunctions = commentCloudFunctions(Firebase);

  var viewTranslatedComment = function viewTranslatedComment(commentUuid, caseUuid) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var comment, currentLanguageCode, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                comment = selectCaseComment(getState(), commentUuid, caseUuid);
                dispatch({
                  type: TRANSLATE_COMMENT,
                  commentUuid: comment.commentUuid
                });
                currentLanguageCode = selectCurrentLanguageCode(getState());

                if (!hasTranslation(comment.translations, currentLanguageCode)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", dispatch(viewTranslatedCommentSuccess(comment.commentUuid)));

              case 5:
                _context.prev = 5;
                _context.next = 8;
                return cloudFunctions.translateComment(comment.commentUuid, currentLanguageCode);

              case 8:
                response = _context.sent;

                if (!isRequestSuccess(response)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", dispatch(viewTranslatedCommentSuccess(comment.commentUuid)));

              case 13:
                return _context.abrupt("return", dispatch(viewTranslatedCommentError(comment.commentUuid, "failed to sync translation due to server error")));

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](5);
                return _context.abrupt("return", dispatch(viewTranslatedCommentError(comment.commentUuid, _context.t0.message)));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 16]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  var viewTranslatedCommentSuccess = function viewTranslatedCommentSuccess(commentUuid) {
    return {
      type: TRANSLATE_COMMENT_COMPLETE,
      commentUuid: commentUuid,
      error: false,
      message: undefined
    };
  };

  var viewTranslatedCommentError = function viewTranslatedCommentError(commentUuid, errorMessage) {
    return {
      type: TRANSLATE_COMMENT_COMPLETE,
      commentUuid: commentUuid,
      error: true,
      message: errorMessage
    };
  };

  var viewOriginalComment = function viewOriginalComment(commentUuid) {
    return {
      type: VIEW_ORIGINAL_COMMENT,
      commentUuid: commentUuid
    };
  };

  var markAcceptedAnswer = function markAcceptedAnswer(_ref2) {
    var commentUuid = _ref2.commentUuid,
        isAnswer = _ref2.isAnswer;
    return /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: MARK_ACCEPTED_ANSWER,
                  payload: {
                    commentUuid: commentUuid,
                    isAnswer: isAnswer
                  }
                });
                _context2.prev = 1;
                _context2.next = 4;
                return cloudFunctions.markAcceptedAnswerCall({
                  commentUuid: commentUuid,
                  isAnswer: isAnswer
                });

              case 4:
                response = _context2.sent;

                if (!isRequestSuccess(response)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", dispatch({
                  type: MARK_ACCEPTED_ANSWER_COMPLETE,
                  payload: {
                    success: response.store
                  }
                }));

              case 9:
                return _context2.abrupt("return", dispatch({
                  type: MARK_ACCEPTED_ANSWER_COMPLETE,
                  error: true,
                  message: "failed to mark accepted answer due to request error"
                }));

              case 10:
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](1);
                return _context2.abrupt("return", dispatch({
                  type: MARK_ACCEPTED_ANSWER_COMPLETE,
                  error: true,
                  message: _context2.t0.message
                }));

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 12]]);
      }));

      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }();
  };

  return {
    viewTranslatedComment: viewTranslatedComment,
    viewOriginalComment: viewOriginalComment,
    markAcceptedAnswer: markAcceptedAnswer
  };
};

var actionsPrefix$7 = "localization";
var LOCALIZATION_UPDATED = "".concat(actionsPrefix$7, "/LOCALIZATION_UPDATED");

var LocalizationActions = function LocalizationActions() {
  var updateLocalization = function updateLocalization(_ref) {
    var currentLanguage = _ref.currentLanguage;
    return {
      type: LOCALIZATION_UPDATED,
      payload: {
        currentLanguage: currentLanguage
      }
    };
  };

  return {
    updateLocalization: updateLocalization
  };
};

var utils$1 = function utils(Firebase) {
  var firestore = Firebase.firestore;

  var getCollectionRef = function getCollectionRef(collectionName) {
    return firestore.collection(collectionName);
  };

  var getDocRef = function getDocRef(docName) {
    return firestore.doc(docName);
  };

  return {
    getCollectionRef: getCollectionRef,
    getDocRef: getDocRef
  };
};

var REFERENCE_DOCUMENT = "question";

var questionDB = function questionDB(Firebase) {
  var _utils = utils$1(Firebase),
      getCollectionRef = _utils.getCollectionRef;

  var firestore = Firebase.firestore;
  return {
    fetchCaseCMEQuestions: function () {
      var _fetchCaseCMEQuestions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var doc, activeQuestions, snapshot, questions;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getCollectionRef(DB_CONSTANTS.QUESTION).doc(REFERENCE_DOCUMENT).get();

              case 3:
                doc = _context.sent;

                if (!doc.exists) {
                  _context.next = 12;
                  break;
                }

                activeQuestions = doc.data().caseCME.questionSetUuid;
                _context.next = 8;
                return firestore.collection("".concat(DB_CONSTANTS.QUESTION, "/").concat(REFERENCE_DOCUMENT, "/").concat(activeQuestions)).get();

              case 8:
                snapshot = _context.sent;
                questions = [];

                if (!snapshot.empty) {
                  snapshot.docs.forEach(function (doc) {
                    return questions.push(doc.data());
                  });
                }

                return _context.abrupt("return", questions);

              case 12:
                return _context.abrupt("return", []);

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                throw new Error("There was an error fetching questions: ".concat(_context.t0.message));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 15]]);
      }));

      function fetchCaseCMEQuestions() {
        return _fetchCaseCMEQuestions.apply(this, arguments);
      }

      return fetchCaseCMEQuestions;
    }()
  };
};

/** @format */
var questionCloudFunctions = function questionCloudFunctions(Firebase) {
  var functions = Firebase.functions;
  return {
    submitCaseCmeAnswersCall: function () {
      var _submitCaseCmeAnswersCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var caseUuid, answers, degreeType, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                caseUuid = _ref.caseUuid, answers = _ref.answers, degreeType = _ref.degreeType;
                _context.next = 3;
                return functions.httpsCallable("backendQuestionSubmitCaseCmeAnswers")({
                  caseUuid: caseUuid,
                  answers: answers,
                  degreeType: degreeType
                });

              case 3:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function submitCaseCmeAnswersCall(_x) {
        return _submitCaseCmeAnswersCall.apply(this, arguments);
      }

      return submitCaseCmeAnswersCall;
    }()
  };
};

var userCmeDB = function userCmeDB(Firebase) {
  var _utils = utils$1(Firebase),
      getCollectionRef = _utils.getCollectionRef;

  return {
    fetchCompletedCme: function () {
      var _fetchCompletedCme = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var caseUuid, userUid, doc;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                caseUuid = _ref.caseUuid, userUid = _ref.userUid;
                _context.next = 3;
                return getCollectionRef("".concat(DB_CONSTANTS.USER_CME, "/").concat(userUid, "/completed")).doc(caseUuid).get();

              case 3:
                doc = _context.sent;
                return _context.abrupt("return", doc !== null && doc !== void 0 && doc.exists ? doc.data() : null);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetchCompletedCme(_x) {
        return _fetchCompletedCme.apply(this, arguments);
      }

      return fetchCompletedCme;
    }(),
    fetchCompletedCmeAnswers: function () {
      var _fetchCompletedCmeAnswers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
        var caseUuid, userUid, snapshot, answers;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                caseUuid = _ref2.caseUuid, userUid = _ref2.userUid;
                _context2.prev = 1;
                _context2.next = 4;
                return getCollectionRef("".concat(DB_CONSTANTS.USER_CME, "/").concat(userUid, "/completed/").concat(caseUuid, "/answers")).get();

              case 4:
                snapshot = _context2.sent;
                answers = [];

                if (!snapshot.empty) {
                  snapshot.docs.forEach(function (doc) {
                    answers.push(doc.data());
                  });
                }

                return _context2.abrupt("return", answers);

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](1);
                console.log("There was an error fetching cme answers: ", _context2.t0.message);
                throw new Error("There was an error fetching cme answers");

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 10]]);
      }));

      function fetchCompletedCmeAnswers(_x2) {
        return _fetchCompletedCmeAnswers.apply(this, arguments);
      }

      return fetchCompletedCmeAnswers;
    }()
  };
};

var actionsPrefix$6 = "userCme";
var FETCH_COMPLETED_CASE_CME = "".concat(actionsPrefix$6, "/FETCH_COMPLETED_CASE_CME");
var FETCH_COMPLETED_CASE_CME_COMPLETE = "".concat(actionsPrefix$6, "/FETCH_COMPLETED_CASE_CME_COMPLETE");
var FETCH_COMPLETED_CASE_CME_ANSWERS = "".concat(actionsPrefix$6, "/FETCH_COMPLETED_CASE_CME_ANSWERS");
var FETCH_COMPLETED_CASE_CME_ANSWERS_COMPLETE = "".concat(actionsPrefix$6, "/FETCH_COMPLETED_CASE_CME_ANSWERS_COMPLETE");
var MARK_CASE_CME_AS_COMPLETE = "".concat(actionsPrefix$6, "/MARK_CASE_CME_AS_COMPLETE");

var UserCmeActions = function UserCmeActions(Firebase) {
  var db = userCmeDB(Firebase);

  var fetchCompletedCmeIfNeeded = function fetchCompletedCmeIfNeeded(caseUuid) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var existingDoc, userUid, doc;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                existingDoc = getState().userCme.data[caseUuid];

                if (isEmpty(existingDoc)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                dispatch({
                  type: FETCH_COMPLETED_CASE_CME
                });
                userUid = getState().user.userUid;
                _context.next = 8;
                return db.fetchCompletedCme({
                  caseUuid: caseUuid,
                  userUid: userUid
                });

              case 8:
                doc = _context.sent;
                return _context.abrupt("return", dispatch({
                  type: FETCH_COMPLETED_CASE_CME_COMPLETE,
                  payload: {
                    caseUuid: caseUuid,
                    data: doc
                  }
                }));

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0.message);
                return _context.abrupt("return", dispatch({
                  type: FETCH_COMPLETED_CASE_CME_COMPLETE,
                  error: true,
                  message: _context.t0.message
                }));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  var markCaseCmeAsComplete = function markCaseCmeAsComplete(caseUuid) {
    return {
      type: MARK_CASE_CME_AS_COMPLETE,
      payload: {
        caseUuid: caseUuid
      }
    };
  };

  var fetchCompletedCmeAnswers = function fetchCompletedCmeAnswers(caseUuid) {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var _getState$userCme, _getState$userCme$dat, userUid, existingDoc, answers;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                userUid = getState().user.userUid;
                existingDoc = (_getState$userCme = getState().userCme) === null || _getState$userCme === void 0 ? void 0 : (_getState$userCme$dat = _getState$userCme.data[caseUuid]) === null || _getState$userCme$dat === void 0 ? void 0 : _getState$userCme$dat.answers;

                if (isEmpty(existingDoc)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                dispatch({
                  type: FETCH_COMPLETED_CASE_CME_ANSWERS
                });
                _context2.next = 8;
                return db.fetchCompletedCmeAnswers({
                  caseUuid: caseUuid,
                  userUid: userUid
                });

              case 8:
                answers = _context2.sent;
                return _context2.abrupt("return", dispatch({
                  type: FETCH_COMPLETED_CASE_CME_ANSWERS_COMPLETE,
                  payload: {
                    caseUuid: caseUuid,
                    data: answers
                  }
                }));

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0.message);
                return _context2.abrupt("return", dispatch({
                  type: FETCH_COMPLETED_CASE_CME_ANSWERS_COMPLETE,
                  error: true,
                  message: _context2.t0.message
                }));

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 12]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();
  };

  return {
    fetchCompletedCmeIfNeeded: fetchCompletedCmeIfNeeded,
    markCaseCmeAsComplete: markCaseCmeAsComplete,
    fetchCompletedCmeAnswers: fetchCompletedCmeAnswers
  };
};

var actionsPrefix$5 = "question";
var FETCH_CASE_CME_QUESTIONS = "".concat(actionsPrefix$5, "/FETCH_CASE_CME_QUESTIONS");
var FETCH_CASE_CME_QUESTIONS_COMPLETE = "".concat(actionsPrefix$5, "/FETCH_CASE_CME_QUESTIONS_COMPLETE");
var SUBMIT_QUESTION_ANSWERS_START = "".concat(actionsPrefix$5, "/SUBMIT_QUESTION_ANSWERS_START");
var SUBMIT_QUESTION_ANSWERS_COMPLETE = "".concat(actionsPrefix$5, "/SUBMIT_QUESTION_ANSWERS_COMPLETE");

var QuestionActions = function QuestionActions(Firebase) {
  var db = questionDB(Firebase);
  var cloudFunctions = questionCloudFunctions(Firebase);
  var userCmeActions = UserCmeActions(Firebase);

  var sortByDisplayOrder = function sortByDisplayOrder(a, b) {
    return a.displayOrder - b.displayOrder;
  };

  var fetchCaseCMEQuestions = function fetchCaseCMEQuestions() {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
        var questions;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: FETCH_CASE_CME_QUESTIONS
                });
                _context.prev = 1;
                _context.next = 4;
                return db.fetchCaseCMEQuestions();

              case 4:
                questions = _context.sent;

                if (!_.isEmpty(questions)) {
                  // questions come back as objects key'd to themselves, so pull out the actual question
                  // big ol' stack of sorting
                  questions.sort(sortByDisplayOrder);
                  questions.forEach(function (q) {
                    q.answerGroups.sort(sortByDisplayOrder);
                    q.answerGroups.forEach(function (ag) {
                      ag.answers.sort(sortByDisplayOrder);
                    });
                  });
                  dispatch({
                    type: FETCH_CASE_CME_QUESTIONS_COMPLETE,
                    data: questions
                  });
                } else {
                  dispatch({
                    type: FETCH_CASE_CME_QUESTIONS_COMPLETE,
                    error: true,
                    message: "Failed to fetch questions"
                  });
                }

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                dispatch({
                  type: FETCH_CASE_CME_QUESTIONS_COMPLETE,
                  error: true,
                  message: _context.t0.message
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  var submitCaseCmeAnswers = function submitCaseCmeAnswers(_ref2) {
    var caseUuid = _ref2.caseUuid,
        answers = _ref2.answers,
        degreeType = _ref2.degreeType;
    return /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                dispatch({
                  type: SUBMIT_QUESTION_ANSWERS_START,
                  caseUuid: caseUuid
                });
                _context2.next = 4;
                return cloudFunctions.submitCaseCmeAnswersCall({
                  caseUuid: caseUuid,
                  degreeType: degreeType,
                  answers: answers
                });

              case 4:
                response = _context2.sent;

                if (!isRequestSuccess(response)) {
                  _context2.next = 10;
                  break;
                }

                dispatch(userCmeActions.markCaseCmeAsComplete(caseUuid));
                return _context2.abrupt("return", dispatch({
                  type: SUBMIT_QUESTION_ANSWERS_COMPLETE,
                  caseUuid: caseUuid,
                  degreeType: degreeType
                }));

              case 10:
                throw new Error("Failed to submit answers to backend");

              case 11:
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", dispatch({
                  type: SUBMIT_QUESTION_ANSWERS_COMPLETE,
                  caseUuid: caseUuid,
                  error: true,
                  message: _context2.t0.message
                }));

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 13]]);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
  };

  return {
    fetchCaseCMEQuestionsIfNeeded: function fetchCaseCMEQuestionsIfNeeded() {
      return /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
          var _getState, _getState$question;

          var questions;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  questions = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$question = _getState.question) === null || _getState$question === void 0 ? void 0 : _getState$question.data;

                  if (_.isEmpty(questions)) {
                    dispatch(fetchCaseCMEQuestions());
                  }

                  return _context3.abrupt("return");

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3, _x4) {
          return _ref4.apply(this, arguments);
        };
      }();
    },
    fetchCaseCMEQuestions: fetchCaseCMEQuestions,
    submitCaseCmeAnswers: submitCaseCmeAnswers
  };
};

var configurationDB = function configurationDB(Firebase) {
  var _utils = utils$1(Firebase),
      getDocRef = _utils.getDocRef;

  return {
    getVersionConfigs: function () {
      var _getVersionConfigs = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var docSnapshot;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getDocRef("".concat(DB_CONSTANTS.CONFIGURATION, "/versions")).get();

              case 3:
                docSnapshot = _context.sent;
                return _context.abrupt("return", docSnapshot.exists ? docSnapshot.data() : {});

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.log("There was an error fetching version config: ", _context.t0.message);
                throw new Error("There was an error fetching version config");

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      function getVersionConfigs() {
        return _getVersionConfigs.apply(this, arguments);
      }

      return getVersionConfigs;
    }()
  };
};

var actionsPrefix$4 = "configuration";
var FETCH_VERSION_CONFIGS = "".concat(actionsPrefix$4, "/FETCH_VERSION_CONFIGS");
var FETCH_VERSION_CONFIGS_COMPLETE = "".concat(actionsPrefix$4, "/FETCH_VERSION_CONFIGS_COMPLETE");

var ConfigurationActions = function ConfigurationActions(Firebase) {
  var db = configurationDB(Firebase);

  var fetchVersionConfigs = function fetchVersionConfigs() {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
        var versions;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: FETCH_VERSION_CONFIGS
                });
                _context.prev = 1;
                _context.next = 4;
                return db.getVersionConfigs();

              case 4:
                versions = _context.sent;
                dispatch({
                  type: FETCH_VERSION_CONFIGS_COMPLETE,
                  payload: {
                    versions: versions
                  }
                });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                dispatch({
                  type: FETCH_VERSION_CONFIGS_COMPLETE,
                  error: true,
                  message: _context.t0.message
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  return {
    fetchVersionConfigs: fetchVersionConfigs
  };
};

var anonymousAuthorsDB = function anonymousAuthorsDB(Firebase) {
  var _utils = utils$1(Firebase),
      getCollectionRef = _utils.getCollectionRef;

  return {
    listenForAuthorChanges: function () {
      var _listenForAuthorChanges = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userUid, callback) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", getCollectionRef("".concat(DB_CONSTANTS.ANONYMOUS_AUTHORS)).doc(userUid).onSnapshot(callback, function (onObservableNextOrError) {
                  console.error("onObservableNextOrError: ", onObservableNextOrError);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function listenForAuthorChanges(_x, _x2) {
        return _listenForAuthorChanges.apply(this, arguments);
      }

      return listenForAuthorChanges;
    }()
  };
};

var actionsPrefix$3 = "anonymousAuthorsActions";
var FETCH_ANONYMOUS_AUTHORS_UUIDS = "".concat(actionsPrefix$3, "/FETCH_ANONYMOUS_AUTHORS_UUIDS");
var FETCH_ANONYMOUS_AUTHORS_UPDATE = "".concat(actionsPrefix$3, "/FETCH_ANONYMOUS_AUTHORS_UPDATE");
var DEFAULT_LISTENER_ON = "".concat(actionsPrefix$3, "/DEFAULT_LISTENER_ON");
var LISTENERS_OFF = "".concat(actionsPrefix$3, "/LISTENERS_OFF");

var AnonymousAuthorsActions = function AnonymousAuthorsActions(Firebase) {
  var db = anonymousAuthorsDB(Firebase);

  var activateListener = function activateListener(userUid) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var listeners, listener;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                listeners = getState().anonymousAuthors.listeners;

                if (listeners.defaultListener) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return db.listenForAuthorChanges(userUid, function (querySnapshot) {
                  if (querySnapshot && querySnapshot.exists) {
                    dispatch({
                      type: FETCH_ANONYMOUS_AUTHORS_UPDATE,
                      payload: {
                        data: querySnapshot.data()
                      },
                      error: false,
                      message: "successfully updated anonymousAuthors"
                    });
                  } else {
                    console.log("There is no firestore entry in the anonymousAuthors collection");
                  }
                });

              case 5:
                listener = _context.sent;
                dispatch({
                  type: DEFAULT_LISTENER_ON,
                  listener: listener
                });

              case 7:
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.log("ERROR: ", _context.t0.message);
                dispatch({
                  type: FETCH_ANONYMOUS_AUTHORS_UPDATE,
                  error: true,
                  message: _context.t0.message
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
  }; // This function can probably be used for _any_ listener pattern.
  // TODO: dry this out so it can be re-used.


  var deactivateAllListeners = function deactivateAllListeners() {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
        var listeners;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  listeners = getState().anonymousAuthors.listeners;

                  if (!isEmpty(listeners)) {
                    Object.values(listeners).forEach( /*#__PURE__*/function () {
                      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(unsubscribe) {
                        return regeneratorRuntime.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                _context2.next = 2;
                                return unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe();

                              case 2:
                                return _context2.abrupt("return", _context2.sent);

                              case 3:
                              case "end":
                                return _context2.stop();
                            }
                          }
                        }, _callee2);
                      }));

                      return function (_x5) {
                        return _ref3.apply(this, arguments);
                      };
                    }());
                    dispatch({
                      type: LISTENERS_OFF
                    });
                  }
                } catch (error) {
                  dispatch({
                    type: FETCH_ANONYMOUS_AUTHORS_UPDATE,
                    error: true,
                    message: error.message
                  });
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();
  };

  return {
    activateListener: activateListener,
    deactivateAllListeners: deactivateAllListeners
  };
};

var whatsNewFlagDb = function whatsNewFlagDb(Firebase) {
  var firestore = Firebase.firestore,
      auth = Firebase.auth;
  return {
    fetchFlags: function () {
      var _fetchFlags = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var doc;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return firestore.collection(DB_CONSTANTS.WHATS_NEW_FLAG).doc(auth.currentUser.uid).get();

              case 2:
                doc = _context.sent;
                return _context.abrupt("return", doc.exists ? doc.data() : {});

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetchFlags() {
        return _fetchFlags.apply(this, arguments);
      }

      return fetchFlags;
    }(),
    markFlagShown: function () {
      var _markFlagShown = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(flagKey) {
        var ref;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ref = firestore.collection(DB_CONSTANTS.WHATS_NEW_FLAG).doc(auth.currentUser.uid);
                _context2.next = 3;
                return ref.set(_defineProperty({}, flagKey, true), {
                  merge: true
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function markFlagShown(_x) {
        return _markFlagShown.apply(this, arguments);
      }

      return markFlagShown;
    }()
  };
};

var actionsPrefix$2 = "whatsNew";
var FETCH_WHATS_NEW_FLAGS = "".concat(actionsPrefix$2, "/FETCH_WHATS_NEW_FLAGS");
var FETCH_WHATS_NEW_FLAGS_COMPLETE = "".concat(actionsPrefix$2, "/FETCH_WHATS_NEW_FLAGS_COMPLETE");
var SET_WHATS_NEW_FLAGS = "".concat(actionsPrefix$2, "/SET_WHATS_NEW_FLAGS");
var SET_WHATS_NEW_FLAGS_COMPLETE = "".concat(actionsPrefix$2, "/SET_WHATS_NEW_FLAGS_COMPLETE");

var WhatsNewActions = function WhatsNewActions(Firebase) {
  var flagDb = whatsNewFlagDb(Firebase);

  var fetchFlags = function fetchFlags() {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
        var flags;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                dispatch({
                  type: FETCH_WHATS_NEW_FLAGS
                });
                _context.next = 4;
                return flagDb.fetchFlags();

              case 4:
                flags = _context.sent;
                return _context.abrupt("return", dispatch({
                  type: FETCH_WHATS_NEW_FLAGS_COMPLETE,
                  payload: {
                    flags: flags
                  }
                }));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                console.log("failed to load what's new flags", _context.t0.message);
                return _context.abrupt("return", dispatch({
                  type: FETCH_WHATS_NEW_FLAGS_COMPLETE,
                  error: true,
                  message: _context.t0.message
                }));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  var markAsShown = function markAsShown(flagKey) {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                dispatch({
                  type: SET_WHATS_NEW_FLAGS,
                  payload: {
                    flagKey: flagKey
                  }
                });
                _context2.next = 4;
                return flagDb.markFlagShown(flagKey);

              case 4:
                return _context2.abrupt("return", dispatch({
                  type: SET_WHATS_NEW_FLAGS_COMPLETE,
                  payload: {
                    flagKey: flagKey
                  }
                }));

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.log("failed to set what's new flag", _context2.t0.message);
                return _context2.abrupt("return", dispatch({
                  type: SET_WHATS_NEW_FLAGS_COMPLETE,
                  error: true,
                  message: _context2.t0.message
                }));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
  };

  return {
    fetchFlags: fetchFlags,
    markAsShown: markAsShown
  };
};

var activityCentreDB = function activityCentreDB(Firebase) {
  var auth = Firebase.auth;

  var _utils = utils$1(Firebase),
      getDocRef = _utils.getDocRef,
      getCollectionRef = _utils.getCollectionRef;

  return {
    getActivityBatch: function () {
      var _getActivityBatch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(limit, startAfterTimestamp, callback) {
        var user, allUserActivityRecordSnapshot, allActivity;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                user = auth.currentUser;
                _context2.next = 3;
                return getCollectionRef("".concat(DB_CONSTANTS.USER_NOTIFICATION, "/").concat(user.uid, "/notifications")).orderBy("createdAt", "desc").startAfter(startAfterTimestamp).limit(limit).get();

              case 3:
                allUserActivityRecordSnapshot = _context2.sent;
                allActivity = [];
                allUserActivityRecordSnapshot.forEach( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(doc) {
                    var data;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            data = doc.data();
                            data.activityId = doc.id;
                            allActivity.push(data);

                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x4) {
                    return _ref.apply(this, arguments);
                  };
                }());
                callback(allActivity);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getActivityBatch(_x, _x2, _x3) {
        return _getActivityBatch.apply(this, arguments);
      }

      return getActivityBatch;
    }(),
    listenForUserActivityRecordChanges: function () {
      var _listenForUserActivityRecordChanges = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(callback) {
        var user, userActivityRecordDocument;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                user = auth.currentUser;
                userActivityRecordDocument = getCollectionRef(DB_CONSTANTS.USER_NOTIFICATION).doc(user.uid);
                return _context3.abrupt("return", userActivityRecordDocument.onSnapshot(function (userActivityRecordSnapshot) {
                  callback(userActivityRecordSnapshot.data());
                }, function (onObservableNextOrError) {
                  console.log("onObservableNextOrError: ", onObservableNextOrError);
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function listenForUserActivityRecordChanges(_x5) {
        return _listenForUserActivityRecordChanges.apply(this, arguments);
      }

      return listenForUserActivityRecordChanges;
    }(),
    getVersionConfigs: function () {
      var _getVersionConfigs = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var docSnapshot;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return getDocRef("".concat(DB_CONSTANTS.CONFIGURATION, "/versions")).get();

              case 3:
                docSnapshot = _context4.sent;
                return _context4.abrupt("return", docSnapshot.exists ? docSnapshot.data() : {});

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                console.log("There was an error fetching version config: ", _context4.t0.message);
                throw new Error("There was an error fetching version config");

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 7]]);
      }));

      function getVersionConfigs() {
        return _getVersionConfigs.apply(this, arguments);
      }

      return getVersionConfigs;
    }()
  };
};

/** @format */
var activityCentreCloudFunctions = function activityCentreCloudFunctions(Firebase) {
  var functions = Firebase.functions;

  var coreCall = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fn, userUid, notificationUuid) {
      var data, result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = {
                user_uid: userUid
              };

              if (notificationUuid) {
                data["notification_uuid"] = notificationUuid;
              }

              _context.next = 4;
              return functions.httpsCallable(fn)(data);

            case 4:
              result = _context.sent;
              return _context.abrupt("return", result);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function coreCall(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  var acknowledgeCall = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(userUid, notificationUuid) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return coreCall("backendActivityCentreMarkAcknowledged", userUid, notificationUuid);

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function acknowledgeCall(_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();

  var readCall = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(userUid, notificationUuid) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return coreCall("backendActivityCentreMarkRead", userUid, notificationUuid);

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function readCall(_x6, _x7) {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    markAllAcknowledgedCall: function () {
      var _markAllAcknowledgedCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(userUid) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return acknowledgeCall(userUid);

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function markAllAcknowledgedCall(_x8) {
        return _markAllAcknowledgedCall.apply(this, arguments);
      }

      return markAllAcknowledgedCall;
    }(),
    markAsAcknowledgedCall: function () {
      var _markAsAcknowledgedCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(userUid, notificationUuid) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return acknowledgeCall(userUid, notificationUuid);

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function markAsAcknowledgedCall(_x9, _x10) {
        return _markAsAcknowledgedCall.apply(this, arguments);
      }

      return markAsAcknowledgedCall;
    }(),
    markAllReadCall: function () {
      var _markAllReadCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(userUid) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return readCall(userUid);

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function markAllReadCall(_x11) {
        return _markAllReadCall.apply(this, arguments);
      }

      return markAllReadCall;
    }(),
    markAsReadCall: function () {
      var _markAsReadCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(userUid, notificationUuid) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return readCall(userUid, notificationUuid);

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function markAsReadCall(_x12, _x13) {
        return _markAsReadCall.apply(this, arguments);
      }

      return markAsReadCall;
    }()
  };
};

var actionsPrefix$1 = "activityCenter";
var FETCH_USER_ACTIVITY_RECORDS = "".concat(actionsPrefix$1, "/FETCH_USER_ACTIVITY_RECORDS");
var FETCH_USER_ACTIVITY_RECORDS_COMPLETE = "".concat(actionsPrefix$1, "/FETCH_USER_ACTIVITY_RECORDS_COMPLETE");
var FETCH_USER_ACTIVITY_RECORDS_ERROR = "".concat(actionsPrefix$1, "/FETCH_USER_ACTIVITY_RECORDS_ERROR");
var SUBSCRIBE_USER_ACTIVITY_METADATA = "".concat(actionsPrefix$1, "/SUBSCRIBE_USER_ACTIVITY_METADATA");
var FETCH_USER_ACTIVITY_METADATA_COMPLETE = "".concat(actionsPrefix$1, "/FETCH_USER_ACTIVITY_METADATA_COMPLETE");
var FETCH_USER_ACTIVITY_METADATA_ERROR = "".concat(actionsPrefix$1, "/FETCH_USER_ACTIVITY_METADATA_ERROR");
var SUBSCRIBE_USER_ACTIVITY_METADATA_LISTENER_ON = "".concat(actionsPrefix$1, "/SUBSCRIBE_USER_ACTIVITY_METADATA_LISTENER_ON");
var SUBSCRIBE_USER_ACTIVITY_METADATA_LISTENER_OFF = "".concat(actionsPrefix$1, "/SUBSCRIBE_USER_ACTIVITY_METADATA_LISTENER_OFF");
var SET_ALL_ACTIVITY_READ = "".concat(actionsPrefix$1, "/SET_ALL_ACTIVITY_READ");
var SET_ALL_ACTIVITY_READ_COMPLETE = "".concat(actionsPrefix$1, "/SET_ALL_ACTIVITY_READ_COMPLETE");
var SET_ALL_ACTIVITY_READ_ERROR = "".concat(actionsPrefix$1, "/SET_ALL_ACTIVITY_READ_ERROR");
var SET_ALL_ACTIVITY_ACKNOWLEDGE = "".concat(actionsPrefix$1, "/SET_ALL_ACTIVITY_ACKNOWLEDGE");
var SET_ALL_ACTIVITY_ACKNOWLEDGE_COMPLETE = "".concat(actionsPrefix$1, "/SET_ALL_ACTIVITY_ACKNOWLEDGE_COMPLETE");
var SET_ALL_ACTIVITY_ACKNOWLEDGE_ERROR = "".concat(actionsPrefix$1, "/SET_ALL_ACTIVITY_ACKNOWLEDGE_ERROR");
var SET_ACTIVITY_READ = "".concat(actionsPrefix$1, "/SET_ACTIVITY_READ");
var SET_ACTIVITY_READ_COMPLETE = "".concat(actionsPrefix$1, "/SET_ACTIVITY_READ_COMPLETE");
var SET_ACTIVITY_READ_ERROR = "".concat(actionsPrefix$1, "/SET_ACTIVITY_READ_ERROR");
var SET_ACTIVITY_ACKNOWLEDGE = "".concat(actionsPrefix$1, "/SET_ACTIVITY_ACKNOWLEDGE");
var SET_ACTIVITY_ACKNOWLEDGE_COMPLETE = "".concat(actionsPrefix$1, "/SET_ACTIVITY_ACKNOWLEDGE_COMPLETE");
var SET_ACTIVITY_ACKNOWLEDGE_ERROR = "".concat(actionsPrefix$1, "/SET_ACTIVITY_ACKNOWLEDGE_ERROR");

var ActivityCentreActions = function ActivityCentreActions(Firebase) {
  var db = activityCentreDB(Firebase);
  var cloudFunctions = activityCentreCloudFunctions(Firebase);
  /**
   * Initialize a listener for user activity meta data and store its unsubscribe function
   * in the redux store. If subscription exists already, do nothing.
   * @param {bool} subscriptionExists
   */

  var activateActivityMetaDataListener = function activateActivityMetaDataListener() {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var _getState, _getState$activity;

        var subscriptionExists, _getState2, _getState2$activity, listener;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                subscriptionExists = !!((_getState = getState()) !== null && _getState !== void 0 && (_getState$activity = _getState.activity) !== null && _getState$activity !== void 0 && _getState$activity.metaDataListener);

                if (!subscriptionExists) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                dispatch({
                  type: SUBSCRIBE_USER_ACTIVITY_METADATA
                });
                _context.prev = 4;

                if ((_getState2 = getState()) !== null && _getState2 !== void 0 && (_getState2$activity = _getState2.activity) !== null && _getState2$activity !== void 0 && _getState2$activity.metaDataListener) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return db.listenForUserActivityRecordChanges(function (metadata) {
                  dispatch({
                    type: FETCH_USER_ACTIVITY_METADATA_COMPLETE,
                    payload: {
                      metadata: metadata
                    }
                  });
                });

              case 8:
                listener = _context.sent;
                dispatch({
                  type: SUBSCRIBE_USER_ACTIVITY_METADATA_LISTENER_ON,
                  payload: {
                    listener: listener
                  }
                });

              case 10:
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](4);
                dispatch({
                  type: FETCH_USER_ACTIVITY_METADATA_ERROR,
                  payload: {
                    message: _context.t0.message
                  }
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 12]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  var deactivateActivityMetaDataListener = function deactivateActivityMetaDataListener() {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var _getState3;

        var unsubscribeMetaData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                unsubscribeMetaData = (_getState3 = getState()) === null || _getState3 === void 0 ? void 0 : _getState3.activity.metaDataListener;

                if (!unsubscribeMetaData) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return unsubscribeMetaData();

              case 4:
                dispatch({
                  type: SUBSCRIBE_USER_ACTIVITY_METADATA_LISTENER_OFF
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();
  };

  var setAllActivityAcknowledged = function setAllActivityAcknowledged() {
    return /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
        var _getState4, _getState4$user;

        var userUid, result, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                userUid = (_getState4 = getState()) === null || _getState4 === void 0 ? void 0 : (_getState4$user = _getState4.user) === null || _getState4$user === void 0 ? void 0 : _getState4$user.userUid;
                dispatch({
                  type: SET_ALL_ACTIVITY_ACKNOWLEDGE
                });
                _context3.prev = 2;
                _context3.next = 5;
                return cloudFunctions.markAllAcknowledgedCall(userUid);

              case 5:
                result = _context3.sent;

                if (result.error) {
                  dispatch({
                    type: SET_ALL_ACTIVITY_ACKNOWLEDGE_ERROR,
                    message: result.error
                  });
                } else {
                  dispatch({
                    type: SET_ALL_ACTIVITY_ACKNOWLEDGE_COMPLETE
                  });
                }

                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](2);
                message = (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message) || _context3.t0;
                dispatch({
                  type: SET_ALL_ACTIVITY_ACKNOWLEDGE_ERROR,
                  message: message
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 9]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }();
  };

  var setActivityAsAcknowledged = function setActivityAsAcknowledged(notificationUuid) {
    return /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
        var _getState5, _getState5$user;

        var userUid, result, message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                userUid = (_getState5 = getState()) === null || _getState5 === void 0 ? void 0 : (_getState5$user = _getState5.user) === null || _getState5$user === void 0 ? void 0 : _getState5$user.userUid;
                dispatch({
                  type: SET_ACTIVITY_ACKNOWLEDGE,
                  notificationUuid: notificationUuid
                });
                _context4.prev = 2;
                _context4.next = 5;
                return activityCentreCloudFunctions.markAsAcknowledgedCall(userUid, notificationUuid);

              case 5:
                result = _context4.sent;

                if (result.error) {
                  dispatch({
                    type: SET_ACTIVITY_ACKNOWLEDGE_ERROR,
                    message: result.error
                  });
                } else {
                  dispatch({
                    type: SET_ACTIVITY_ACKNOWLEDGE_COMPLETE,
                    notificationUuid: notificationUuid
                  });
                }

                _context4.next = 13;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](2);
                message = (_context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.message) || _context4.t0;
                dispatch({
                  type: SET_ACTIVITY_ACKNOWLEDGE_ERROR,
                  message: message
                });

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 9]]);
      }));

      return function (_x7, _x8) {
        return _ref4.apply(this, arguments);
      };
    }();
  };

  var setAllActivityRead = function setAllActivityRead() {
    return /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
        var _getState6, _getState6$user;

        var userUid, result, message;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                userUid = (_getState6 = getState()) === null || _getState6 === void 0 ? void 0 : (_getState6$user = _getState6.user) === null || _getState6$user === void 0 ? void 0 : _getState6$user.userUid;
                dispatch({
                  type: SET_ALL_ACTIVITY_READ
                });
                _context5.prev = 2;
                _context5.next = 5;
                return cloudFunctions.markAllReadCall(userUid);

              case 5:
                result = _context5.sent;

                if (result.error) {
                  dispatch({
                    type: SET_ALL_ACTIVITY_READ_ERROR,
                    message: result.error
                  });
                } else {
                  dispatch({
                    type: SET_ALL_ACTIVITY_READ_COMPLETE
                  });
                }

                _context5.next = 13;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](2);
                message = (_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.message) || _context5.t0;
                dispatch({
                  type: SET_ALL_ACTIVITY_READ_ERROR,
                  message: message
                });

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 9]]);
      }));

      return function (_x9, _x10) {
        return _ref5.apply(this, arguments);
      };
    }();
  };

  var setActivityAsRead = function setActivityAsRead(notificationUuid) {
    return /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
        var _getState7, _getState7$user;

        var userUid, result, message;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                userUid = (_getState7 = getState()) === null || _getState7 === void 0 ? void 0 : (_getState7$user = _getState7.user) === null || _getState7$user === void 0 ? void 0 : _getState7$user.userUid;
                dispatch({
                  type: SET_ACTIVITY_READ,
                  notificationUuid: notificationUuid
                });
                _context6.prev = 2;
                _context6.next = 5;
                return cloudFunctions.markAsReadCall(userUid, notificationUuid);

              case 5:
                result = _context6.sent;

                if (result.error) {
                  dispatch({
                    type: SET_ACTIVITY_READ_ERROR,
                    message: result.error
                  });
                } else {
                  dispatch({
                    type: SET_ACTIVITY_READ_COMPLETE,
                    notificationUuid: notificationUuid
                  });
                }

                _context6.next = 13;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](2);
                message = (_context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.message) || _context6.t0;
                dispatch({
                  type: SET_ACTIVITY_READ_ERROR,
                  message: message
                });

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 9]]);
      }));

      return function (_x11, _x12) {
        return _ref6.apply(this, arguments);
      };
    }();
  };
  /**
   *
   * @param {bool} shouldClearOldActivity used to delete old state only when refreshing the list
   */


  var fetchActivityRecord = function fetchActivityRecord(_ref7) {
    var limit = _ref7.limit,
        _ref7$startAfterTimes = _ref7.startAfterTimestamp,
        startAfterTimestamp = _ref7$startAfterTimes === void 0 ? null : _ref7$startAfterTimes,
        _ref7$shouldClearOldA = _ref7.shouldClearOldActivity,
        shouldClearOldActivity = _ref7$shouldClearOldA === void 0 ? false : _ref7$shouldClearOldA,
        _ref7$callback = _ref7.callback,
        callback = _ref7$callback === void 0 ? null : _ref7$callback;
    return /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                dispatch({
                  type: FETCH_USER_ACTIVITY_RECORDS
                });

                try {
                  db.getActivityBatch(limit, startAfterTimestamp || new Date().toString(), function (allActivity) {
                    dispatch({
                      type: FETCH_USER_ACTIVITY_RECORDS_COMPLETE,
                      payload: {
                        allActivity: allActivity,
                        shouldClearOldActivity: shouldClearOldActivity,
                        isEndReached: allActivity.length < limit
                      }
                    });
                  });

                  if (callback) {
                    callback();
                  }
                } catch (error) {
                  dispatch({
                    type: FETCH_USER_ACTIVITY_RECORDS_ERROR,
                    error: true,
                    message: error.message
                  });
                }

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x13) {
        return _ref8.apply(this, arguments);
      };
    }();
  };

  return {
    activateActivityMetaDataListener: activateActivityMetaDataListener,
    deactivateActivityMetaDataListener: deactivateActivityMetaDataListener,
    fetchActivityRecord: fetchActivityRecord,
    setActivityAsRead: setActivityAsRead,
    setAllActivityRead: setAllActivityRead,
    setActivityAsAcknowledged: setActivityAsAcknowledged,
    setAllActivityAcknowledged: setAllActivityAcknowledged
  };
};

var AccountCloudFunctions = function AccountCloudFunctions(Firebase) {
  var functions = Firebase.functions;

  var resetPasswordCall = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(email) {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return functions.httpsCallable("backendUserPasswordReset")({
                email: email
              });

            case 2:
              result = _context.sent;
              return _context.abrupt("return", result.data);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function resetPasswordCall(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    resetPasswordCall: resetPasswordCall
  };
};

var actionsPrefix = "account";
var ACCOUNT_RESET_PASSWORD = "".concat(actionsPrefix, "/ACCOUNT_RESET_PASSWORD");
var ACCOUNT_RESET_PASSWORD_COMPLETE = "".concat(actionsPrefix, "/ACCOUNT_RESET_PASSWORD_COMPLETE");

var AccountActions = function AccountActions(Firebase) {
  var functions = AccountCloudFunctions(Firebase);
  return {
    resetPassword: function resetPassword() {
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
          var user, result;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  user = getState().user;
                  _context.prev = 1;
                  dispatch({
                    type: ACCOUNT_RESET_PASSWORD
                  });
                  _context.next = 5;
                  return functions.resetPasswordCall(user === null || user === void 0 ? void 0 : user.email);

                case 5:
                  result = _context.sent;

                  if (!isRequestSuccess(result)) {
                    _context.next = 10;
                    break;
                  }

                  return _context.abrupt("return", dispatch({
                    type: ACCOUNT_RESET_PASSWORD_COMPLETE
                  }));

                case 10:
                  throw new Error("reset password call failed");

                case 11:
                  _context.next = 17;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t0 = _context["catch"](1);
                  console.log("failed to reset password: ", _context.t0.message);
                  return _context.abrupt("return", dispatch({
                    type: ACCOUNT_RESET_PASSWORD_COMPLETE,
                    error: true,
                    message: "failed to reset password: ".concat(_context.t0.message)
                  }));

                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 13]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();
    }
  };
};

var actions = function actions(Firebase, AppConfig) {
  return {
    TopicsActions: TopicActions(Firebase),
    FeedsActions: FeedsActions(Firebase),
    ReferenceActions: ReferenceActions(Firebase, AppConfig),
    GroupsActions: GroupsActions(Firebase),
    CaseActions: CaseActions(Firebase),
    CommentActions: CommentActions(Firebase),
    LocalizationActions: LocalizationActions(),
    QuestionActions: QuestionActions(Firebase),
    ConfigurationActions: ConfigurationActions(Firebase),
    UserCmeActions: UserCmeActions(Firebase),
    AnonymousAuthorsActions: AnonymousAuthorsActions(Firebase),
    WhatsNewActions: WhatsNewActions(Firebase),
    ActivityCentreActions: ActivityCentreActions(Firebase),
    AccountActions: AccountActions(Firebase)
  };
};

var INITIAL_STATE$d = {
  data: [],
  selected: {},
  isProcessing: false,
  error: false,
  message: null
};

var TopicsReducer = function TopicsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$d;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_TOPICS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: true
      });

    case FETCH_TOPICS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: false,
        error: action.error,
        data: action.data || state.data,
        message: action.message
      });

    case FOLLOW_TOPIC:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        selected: action.selected
      });

    case FOLLOW_TOPIC_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        error: true,
        message: action.message,
        selected: action.selected
      });

    case FOLLOW_TOPIC_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        selected: action.selected
      });

    default:
      return state;
  }
};

var INITIAL_STATE$c = {
  feedList: {},
  filters: {}
};

var FeedsReducer = function FeedsReducer() {
  var _action$payload, _action$payload2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$c;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_FEED:
      var contents = _objectSpread2(_objectSpread2({}, state.feedList[action.feedTypeUuid]), {}, {
        isProcessing: true
      });

      if (action.clearFeed) {
        contents = _objectSpread2(_objectSpread2({}, state.feedList[action.feedTypeUuid]), {}, {
          feed: [],
          isProcessing: true
        });
      }

      return _objectSpread2(_objectSpread2({}, state), {}, {
        feedList: _objectSpread2(_objectSpread2({}, state.feedList), {}, _defineProperty({}, action.feedTypeUuid, contents))
      });

    case FETCH_FEED_COMPLETE:
      var currentFeed = state.feedList[action.feedTypeUuid];
      return _objectSpread2(_objectSpread2({}, state), {}, {
        feedList: _objectSpread2(_objectSpread2({}, state.feedList), {}, _defineProperty({}, action.feedTypeUuid, _objectSpread2(_objectSpread2({}, currentFeed), {}, {
          feed: [].concat(_toConsumableArray((currentFeed === null || currentFeed === void 0 ? void 0 : currentFeed.feed) || []), _toConsumableArray(((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.feed) || [])),
          eof: ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.is_eof) || false,
          isProcessing: false,
          error: action.error,
          message: action.message
        })))
      });

    case UPDATE_FEED_FILTERS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        filters: _objectSpread2(_objectSpread2({}, state.filters), {}, _defineProperty({}, action.feedTypeUuid, action.filters))
      });

    default:
      return state;
  }
};

var COUNTRIES = {
  usa: "United States",
  canada: "Canada"
};

var INITIAL_STATE$b = {
  isLoading: false,
  error: null,
  fallbackLocations: {
    isLoadingFallbackLocations: false,
    countries: [],
    regions: [] // states and provinces

  },
  professions: [],
  professionSpecialties: {},
  interests: [],
  feeds: {},
  feedsMeta: {},
  country: null
};

var referenceReducer = function referenceReducer() {
  var _action$payload, _action$payload4, _action$payload5, _state$feeds$action$p, _action$payload6, _action$payload7;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$b;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_PROFESSIONS:
    case FETCH_PROFESSION_SPECIALTIES:
    case FETCH_INTERESTS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: true
      });

    case FETCH_FALLBACK_LOCATIONS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        fallbackLocations: _objectSpread2(_objectSpread2({}, state.fallbackLocations), {}, {
          isLoadingFallbackLocations: true
        })
      });

    case FETCH_FALLBACK_LOCATIONS_COMPLETE:
      return formatFallbackLocations(state, action);

    case FETCH_PROFESSIONS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: false,
        professions: formatProfessions(action.payload.professions)
      });

    case FETCH_PROFESSION_SPECIALTIES_COMPLETE:
      if (action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.professionUuid) {
        var _action$payload2, _action$payload3;

        var newSpecialties = _objectSpread2({}, state.professionSpecialties);

        newSpecialties[action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.professionUuid] = action === null || action === void 0 ? void 0 : (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.professionSpecialties;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isLoading: false,
          professionSpecialties: _objectSpread2({}, newSpecialties)
        });
      }

      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: false
      });

    case FETCH_INTERESTS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: false,
        interests: action === null || action === void 0 ? void 0 : (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.interests
      });

    case FETCH_PROFESSIONS_ERROR:
    case FETCH_PROFESSION_SPECIALTIES_ERROR:
    case FETCH_INTERESTS_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: false,
        error: action === null || action === void 0 ? void 0 : (_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.error
      });

    case FETCH_PREVIEW_FEED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        feeds: _objectSpread2(_objectSpread2({}, state.feeds), {}, _defineProperty({}, action.payload.feedTypeUuid, {
          data: (_state$feeds$action$p = state.feeds[action.payload.feedTypeUuid]) === null || _state$feeds$action$p === void 0 ? void 0 : _state$feeds$action$p.data,
          loading: true
        }))
      });

    case FETCH_PREVIEW_FEED_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        feeds: _objectSpread2(_objectSpread2({}, state.feeds), {}, _defineProperty({}, action.payload.feedTypeUuid, {
          data: action.payload.feed,
          loading: false
        }))
      });

    case FETCH_PREVIEW_FEED_META:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        feedsMeta: _objectSpread2(_objectSpread2({}, state.feedsMeta), {}, {
          data: {},
          loading: true
        })
      });

    case FETCH_PREVIEW_FEED_META_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        feedsMeta: _objectSpread2(_objectSpread2({}, state.feedsMeta), {}, {
          data: action.payload.feedsMeta,
          loading: false
        })
      });

    case FETCH_COUNTRY_COMPLETE:
      var newProps = {
        country: action === null || action === void 0 ? void 0 : (_action$payload6 = action.payload) === null || _action$payload6 === void 0 ? void 0 : _action$payload6.country
      };

      if (action !== null && action !== void 0 && (_action$payload7 = action.payload) !== null && _action$payload7 !== void 0 && _action$payload7.error) {
        var _action$payload8;

        newProps.error = action === null || action === void 0 ? void 0 : (_action$payload8 = action.payload) === null || _action$payload8 === void 0 ? void 0 : _action$payload8.error;
      }

      return _objectSpread2(_objectSpread2({}, state), newProps);

    case FETCH_GROUPS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        groups: _objectSpread2(_objectSpread2({}, state.groups), {}, {
          data: {},
          loading: true
        })
      });

    case FETCH_GROUPS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        groups: _objectSpread2(_objectSpread2({}, state.groups), {}, {
          data: action.payload.groups,
          loading: false
        })
      });

    default:
      return state;
  }
};
/**
 * Separate profession categories and specific professions and format data for picker.
 *
 * Most profession categories are professions, but there are 2 categories that
 * have multiple different specific professions: "Other HCP" and "Other Student".
 *
 * Non "Other" categories (like physician, nurse etc) only have 1 profession, with
 * the same name as its category, while these "Other" categories have multiple
 * different specific professions. Selecting either of these "Other" professions
 * requires further specification of profession.
 */


var formatProfessions = function formatProfessions(professions) {
  var categories = [];
  var specificProfessions = {};
  Object.keys(professions).forEach(function (key) {
    var profession = professions[key];

    if (!categories.some(function (category) {
      return category.value === profession.professionCategoryLabel;
    })) {
      categories.push(_objectSpread2({
        label: profession.professionCategoryName,
        value: profession.professionCategoryLabel,
        displayOrder: profession.displayOrder
      }, profession.hidden && {
        hidden: profession.hidden
      }));
    } // Create a list of specific professions categorized by profession category


    var currentSpecificProfessions = specificProfessions[profession.professionCategoryLabel] || [];
    specificProfessions[profession.professionCategoryLabel] = [].concat(_toConsumableArray(currentSpecificProfessions), [profession]);
  }); // Format and sort specific professions in each category

  Object.keys(specificProfessions).forEach(function (key) {
    var _professions = ((specificProfessions === null || specificProfessions === void 0 ? void 0 : specificProfessions[key]) || []).map(function (p) {
      return {
        label: p.professionName,
        value: p.professionUuid
      };
    });

    specificProfessions[key] = sortBy(_professions, ["label"]);
  });
  return {
    categories: sortBy(categories, ["displayOrder"]),
    specificProfessions: specificProfessions,
    raw: professions,
    isLoadingProfessions: false
  };
};

var formatFallbackLocations = function formatFallbackLocations(state, action) {
  var countriesAndRegions = action.payload.countriesAndRegions;

  var _countriesAndRegions$ = countriesAndRegions.reduce(function (acc, country) {
    var _country$countryRegio;

    acc.countries.push({
      label: country.countryName,
      value: country.countryUuid,
      countryCode: country.countryCode
    });

    if (country !== null && country !== void 0 && (_country$countryRegio = country.countryRegions) !== null && _country$countryRegio !== void 0 && _country$countryRegio.length) {
      country.countryRegions.forEach(function (r) {
        acc.regions.push({
          regionCode: r.regionCode,
          label: r.regionName,
          value: r.regionUuid,
          countryCode: country.countryUuid
        });
      });
    }

    return acc;
  }, {
    countries: [],
    regions: []
  }),
      countries = _countriesAndRegions$.countries,
      regions = _countriesAndRegions$.regions; // sort country by label. Put US first, Canada second.


  countries.sort(function (a, b) {
    var _a$label;

    if (a.label === b.label) return 0;
    if (a.label === COUNTRIES.usa) return -1;
    if (b.label === COUNTRIES.usa) return 1;
    if (a.label === COUNTRIES.canada) return -1;
    if (b.label === COUNTRIES.canada) return 1;
    return (_a$label = a.label) === null || _a$label === void 0 ? void 0 : _a$label.localeCompare(b.label);
  });
  return _objectSpread2(_objectSpread2({}, state), {}, {
    fallbackLocations: _objectSpread2(_objectSpread2({}, state.fallbackLocations), {}, {
      countries: countries,
      regions: sortBy(regions, "label"),
      isLoadingFallbackLocations: false
    })
  });
};

var INITIAL_STATE$a = {
  translations: {}
};

var caseReducer = function caseReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$a;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case TRANSLATE_CASE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        translations: _objectSpread2(_objectSpread2({}, state.translations), {}, _defineProperty({}, action.caseUuid, {
          isTranslated: false,
          isLoading: true,
          error: null
        }))
      });

    case TRANSLATE_CASE_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        translations: _objectSpread2(_objectSpread2({}, state.translations), {}, _defineProperty({}, action.caseUuid, {
          isTranslated: true,
          isLoading: false,
          error: action.error
        }))
      });

    case VIEW_ORIGINAL_CASE_TRANSLATION:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        translations: _objectSpread2(_objectSpread2({}, state.translations), {}, _defineProperty({}, action.caseUuid, {
          isTranslated: false,
          isLoading: false,
          error: null
        }))
      });

    default:
      return state;
  }
};

var INITIAL_STATE$9 = {
  translations: {},
  acceptProcessing: false
};

var commentReducer = function commentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$9;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case TRANSLATE_COMMENT:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        translations: _objectSpread2(_objectSpread2({}, state.translations), {}, _defineProperty({}, action.commentUuid, {
          isTranslated: false,
          isLoading: true,
          error: null
        }))
      });

    case TRANSLATE_COMMENT_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        translations: _objectSpread2(_objectSpread2({}, state.translations), {}, _defineProperty({}, action.commentUuid, {
          isTranslated: true,
          isLoading: false,
          error: action.error
        }))
      });

    case VIEW_ORIGINAL_COMMENT:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        translations: _objectSpread2(_objectSpread2({}, state.translations), {}, _defineProperty({}, action.commentUuid, {
          isTranslated: false,
          isLoading: false,
          error: null
        }))
      });

    case MARK_ACCEPTED_ANSWER:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        acceptProcessing: true
      });

    case MARK_ACCEPTED_ANSWER_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        acceptProcessing: false
      });

    default:
      return state;
  }
};

var INITIAL_STATE$8 = {
  currentLanguage: "en-US"
};

var localizationReducer = function localizationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$8;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case LOCALIZATION_UPDATED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        currentLanguage: action.payload.currentLanguage
      });

    default:
      return state;
  }
};

var INITIAL_STATE$7 = {
  currentGroup: {},
  invitees: {},
  data: {},
  members: {},
  listener: null,
  isProcessing: false,
  error: null,
  message: null
};

var groupsReducer = function groupsReducer() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$7;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SELECT_GROUP:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        currentGroup: action.payload.group
      });

    case SEND_INVITE:
    case CREATE_GROUP:
    case LEAVE_GROUP:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: true
      });

    case CREATE_GROUP_COMPLETE:
    case LEAVE_GROUP_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: false,
        error: action.error,
        message: action.message
      });

    case SEND_INVITE_COMPLETE:
      var groupUuid = action.payload.groupUuid;
      var oldInvitees = state.invitees[groupUuid] || [];
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: false,
        invitees: _objectSpread2(_objectSpread2({}, state.invitees), {}, _defineProperty({}, groupUuid, _toConsumableArray(new Set([].concat(_toConsumableArray(oldInvitees), _toConsumableArray(action.payload.inviteeUuids || [])))))),
        error: action.error,
        message: action.message
      });

    case GROUPS_LISTENER_ON:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        listener: action.payload.listener
      });

    case GROUPS_LISTENER_OFF:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        listener: null
      });

    case FETCH_GROUPS$1:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: true
      });

    case FETCH_GROUPS_COMPLETE$1:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: false,
        data: _objectSpread2(_objectSpread2({}, state.data), ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.groups) || [])
      });

    case FETCH_GROUP_MEMBERS:
      {
        var _action$payload2, _state$members;

        var _groupUuid = (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.groupUuid;

        var members = (_state$members = state.members) === null || _state$members === void 0 ? void 0 : _state$members[_groupUuid];
        return _objectSpread2(_objectSpread2({}, state), {}, {
          members: _objectSpread2(_objectSpread2({}, state.members), {}, _defineProperty({}, _groupUuid, _objectSpread2(_objectSpread2({}, members), {}, {
            loadingMembers: true
          })))
        });
      }

    case FETCH_GROUP_MEMBERS_COMPLETE:
      {
        var _action$payload3, _state$data$_groupUui, _action$payload4;

        var _groupUuid2 = (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.groupUuid;

        var data = action.error ? (_state$data$_groupUui = state.data[_groupUuid2]) === null || _state$data$_groupUui === void 0 ? void 0 : _state$data$_groupUui.members : (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.members;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          members: _objectSpread2(_objectSpread2({}, state.members), {}, _defineProperty({}, _groupUuid2, {
            loadingMembers: false,
            data: data
          }))
        });
      }

    case CLEAR_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        error: false,
        message: null
      });

    default:
      return state;
  }
};

var INITIAL_STATE$6 = {
  caseCMEQuestions: [],
  isProcessing: false,
  error: false,
  message: null
};

var QuestionReducer = function QuestionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$6;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_CASE_CME_QUESTIONS:
    case SUBMIT_QUESTION_ANSWERS_START:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: true,
        error: false,
        message: null
      });

    case FETCH_CASE_CME_QUESTIONS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: false,
        error: action.error,
        caseCMEQuestions: action.data || state.data,
        message: action.message
      });

    case SUBMIT_QUESTION_ANSWERS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: false,
        error: action.error,
        message: action.message
      });

    default:
      return state;
  }
};

var INITIAL_STATE$5 = {
  data: {},
  versions: {},
  selected: {},
  isProcessing: false,
  error: false,
  message: null,
  listeners: {},
  elasticSearch: {}
};

var configurationReducer = function configurationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$5;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_VERSION_CONFIGS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: true
      });

    case FETCH_VERSION_CONFIGS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: false,
        versions: action.payload.versions,
        error: action.error,
        message: action.message
      });

    default:
      return state;
  }
};

var INITIAL_STATE$4 = {
  meta: {},
  availableActivities: [],
  completedActivities: [],
  metaUnsub: null,
  availableUnsub: null,
  completedUnsub: null,
  isProcessing: false,
  availableInitialized: false,
  completeInitialized: false,
  data: {}
};

var UserCmeReducer = function UserCmeReducer() {
  var _action$payload, _action$payload2, _action$payload3, _action$payload4;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$4;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_COMPLETED_CASE_CME:
    case FETCH_COMPLETED_CASE_CME_ANSWERS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: true
      });

    case FETCH_COMPLETED_CASE_CME_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: false,
        data: _objectSpread2(_objectSpread2({}, state.data), {}, _defineProperty({}, (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.caseUuid, (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.data))
      });

    case FETCH_COMPLETED_CASE_CME_ANSWERS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: false,
        completedCmeAnswers: _objectSpread2(_objectSpread2({}, state.completedCmeAnswers), {}, _defineProperty({}, (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.caseUuid, (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.data))
      });

    case MARK_CASE_CME_AS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        data: _objectSpread2(_objectSpread2({}, state.data), {}, _defineProperty({}, action.payload.caseUuid, {
          completed: true
        }))
      });

    default:
      return state;
  }
};

var INITIAL_STATE$3 = {
  anonymousCaseUuids: [],
  anonymousCommentUuids: [],
  userUid: null,
  isProcessing: false,
  listeners: {}
};

var anonymousAuthorsReducer = function anonymousAuthorsReducer() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$3;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_ANONYMOUS_AUTHORS_UUIDS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: true
      });

    case FETCH_ANONYMOUS_AUTHORS_UPDATE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: false,
        error: action.error,
        message: action.message
      }, (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data);

    case DEFAULT_LISTENER_ON:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        listeners: _objectSpread2(_objectSpread2({}, state.listeners), {}, {
          defaultListener: action.listener
        })
      });

    case LISTENERS_OFF:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        listeners: {}
      });
    // TODO: we need a global reset in brain

    default:
      return state;
  }
};

var INITIAL_STATE$2 = {
  flags: null,
  fetching: false,
  setting: false
};

var whatsNewReducer = function whatsNewReducer() {
  var _action$payload, _action$payload2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$2;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_WHATS_NEW_FLAGS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        fetching: true
      });

    case FETCH_WHATS_NEW_FLAGS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        fetching: false,
        flags: (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.flags,
        error: action.error
      });

    case SET_WHATS_NEW_FLAGS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        setting: true
      });

    case SET_WHATS_NEW_FLAGS_COMPLETE:
      var newFlags = _objectSpread2(_objectSpread2({}, state.flags), {}, _defineProperty({}, (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.flagKey, true));

      return _objectSpread2(_objectSpread2({}, state), {}, {
        setting: false,
        flags: _objectSpread2({}, newFlags)
      });

    default:
      return state;
  }
};

var ACTIVITY_NOTIFICATION_STATE = {
  NEW: "new",
  ACKNOWLEDGED: "acknowledged",
  READ: "read"
};

var INITIAL_STATE$1 = {
  activityMeta: {},
  allActivity: [],
  unreadActivity: [],
  newActivity: [],
  remainingActivity: [],
  metaDataError: null,
  metaDataListener: null,
  activityError: null,
  isActivityLoading: false,
  endReached: false
};

var getNewActivityState = function getNewActivityState(state, _ref) {
  var payload = _ref.payload;

  var newState = _objectSpread2(_objectSpread2({}, state), {}, {
    isActivityLoading: false,
    endReached: payload.isEndReached
  });

  var shouldClearOldActivity = payload.shouldClearOldActivity;
  var newAllActivity = payload.allActivity;

  if (shouldClearOldActivity) {
    newState.allActivity = newAllActivity;
  } else if (newAllActivity.length > 0) {
    newState.allActivity = [].concat(_toConsumableArray(state.allActivity), _toConsumableArray(newAllActivity));
  }

  return newState;
};

var setActivityState = function setActivityState(state, notificationUuid, newActivityState) {
  var newState = _objectSpread2({}, state);

  if (notificationUuid && newState !== null && newState !== void 0 && newState.allActivity) {
    var _newState$allActivity;

    var itemIndex = newState === null || newState === void 0 ? void 0 : (_newState$allActivity = newState.allActivity) === null || _newState$allActivity === void 0 ? void 0 : _newState$allActivity.findIndex(function (activity) {
      return activity.notificationUuid === notificationUuid;
    });

    if (itemIndex >= 0) {
      newState.allActivity[itemIndex].state = newActivityState;
    }
  }

  return newState;
};

var setAllActivityState = function setAllActivityState(state, newActivityState) {
  var newState = _objectSpread2({}, state);

  if (newState !== null && newState !== void 0 && newState.allActivity) {
    var _newState$allActivity2;

    newState.allActivity = newState === null || newState === void 0 ? void 0 : (_newState$allActivity2 = newState.allActivity) === null || _newState$allActivity2 === void 0 ? void 0 : _newState$allActivity2.map(function (activity) {
      activity.state = newActivityState;
      return activity;
    });
  }

  return newState;
};

var activityCentreReducer = function activityCentreReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_USER_ACTIVITY_METADATA_ERROR:
    case SET_ALL_ACTIVITY_READ_ERROR:
    case SET_ALL_ACTIVITY_ACKNOWLEDGE_ERROR:
    case SET_ACTIVITY_READ_ERROR:
    case SET_ACTIVITY_ACKNOWLEDGE_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        metaDataError: action.payload.message
      });

    case FETCH_USER_ACTIVITY_METADATA_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        activityMeta: action.payload.metadata
      });

    case SUBSCRIBE_USER_ACTIVITY_METADATA_LISTENER_ON:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        metaDataListener: action.payload.listener
      });

    case SUBSCRIBE_USER_ACTIVITY_METADATA_LISTENER_OFF:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        metaDataListener: null
      });

    case FETCH_USER_ACTIVITY_RECORDS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isActivityLoading: true
      });

    case FETCH_USER_ACTIVITY_RECORDS_ERROR:
      return {
        activityError: action.message,
        isActivityLoading: false
      };

    case FETCH_USER_ACTIVITY_RECORDS_COMPLETE:
      return getNewActivityState(state, action);

    case SET_ALL_ACTIVITY_ACKNOWLEDGE_COMPLETE:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          activityMeta: _objectSpread2(_objectSpread2({}, state.activityMeta), {}, {
            newActivityCount: null
          })
        });
      }

    case SET_ALL_ACTIVITY_READ_COMPLETE:
      {
        var newState = setAllActivityState(state, ACTIVITY_NOTIFICATION_STATE.READ);
        return _objectSpread2(_objectSpread2({}, newState), {}, {
          activityMeta: _objectSpread2({}, state.activityMeta)
        });
      }

    case SET_ACTIVITY_ACKNOWLEDGE_COMPLETE:
      return setActivityState(state, action.notificationUuid, ACTIVITY_NOTIFICATION_STATE.ACKNOWLEDGED);

    case SET_ACTIVITY_READ_COMPLETE:
      return setActivityState(state, action.notificationUuid, ACTIVITY_NOTIFICATION_STATE.READ);

    default:
      return state;
  }
};

var INITIAL_STATE = {
  resetting: false,
  error: null,
  message: null
};

var accountReducer = function accountReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ACCOUNT_RESET_PASSWORD:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        resetting: true
      });

    case ACCOUNT_RESET_PASSWORD_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        resetting: false,
        error: action.error,
        message: action.message
      });

    default:
      return state;
  }
};

var ReducerStates = {
  FEEDS_INITIAL_STATE: INITIAL_STATE$c,
  TOPICS_INITIAL_STATE: INITIAL_STATE$d,
  REFERENCE_INITIAL_STATE: INITIAL_STATE$b,
  CASE_INITIAL_STATE: INITIAL_STATE$a,
  COMMENT_INITIAL_STATE: INITIAL_STATE$9,
  LOCALIZATION_INITIAL_STATE: INITIAL_STATE$8,
  GROUP_INITIAL_STATE: INITIAL_STATE$7,
  QUESTION_INITIAL_STATE: INITIAL_STATE$6,
  CONFIGURATION_INITIAL_STATE: INITIAL_STATE$5,
  USER_CME_INITIAL_STATE: INITIAL_STATE$4,
  ANONYMOUS_AUTHORS_INITIAL_STATE: INITIAL_STATE$3,
  WHATS_NEW_INITIAL_STATE: INITIAL_STATE$2,
  ACTIVITY_CENTRE_INITIAL_STATE: INITIAL_STATE$1,
  ACCOUNT_INITIAL_STATE: INITIAL_STATE
};
var reducers = {
  TopicsReducer: TopicsReducer,
  FeedsReducer: FeedsReducer,
  ReferenceReducer: referenceReducer,
  CaseReducer: caseReducer,
  CommentReducer: commentReducer,
  LocalizationReducer: localizationReducer,
  GroupsReducer: groupsReducer,
  QuestionReducer: QuestionReducer,
  ConfigurationReducer: configurationReducer,
  UserCmeReducer: UserCmeReducer,
  AnonymousAuthorsReducer: anonymousAuthorsReducer,
  WhatsNewReducer: whatsNewReducer,
  ActivityCentreReducer: activityCentreReducer,
  AccountReducer: accountReducer
};

/** @format */
var CME_TYPES = {
  CASE_CME: "case_cme",
  ACTIVITY: "activity"
};
var CERTIFICATE_STATUS = {
  INELIGIBLE: "ineligible",
  GENERATING: "generating",
  COMPLETED: "completed"
};

var CmeConstants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CME_TYPES: CME_TYPES,
  CERTIFICATE_STATUS: CERTIFICATE_STATUS
});

var ONBOARDING_STATE = {
  SIGN_UP: "sign_up",
  INFORMATION: "information",
  USA_INFORMATION: "usa_information",
  GRAD_DATE: "grad_date",
  VERIFICATION: "verification",
  USERNAME: "username",
  COMPLETED: "completed",
  COUNTRY: "country",
  CONFIRMATION: "confirmation"
};

var constants = {
  CaseState: CaseState,
  CaseType: CaseType,
  CmeConstants: CmeConstants,
  ONBOARDING_STATE: ONBOARDING_STATE
};

/** @format */

var makeUseCaseTranslation = function makeUseCaseTranslation(caseActions) {
  return function (caseContent) {
    var dispatch = useDispatch();
    var isTranslationEnabled = useSelector(function (state) {
      return selectIsTranslationEnabled$1(state, caseContent.caseUuid);
    });
    var isLoadingTranslation = useSelector(function (state) {
      return selectIsLoadingTranslation$1(state, caseContent.caseUuid);
    });
    var isViewingTranslation = useSelector(function (state) {
      return selectIsViewingTranslation$1(state, caseContent.caseUuid);
    });
    var translation = useSelector(function (state) {
      return selectCaseTranslation(state, caseContent.caseUuid);
    });
    var updateTranslations = useSelector(function (state) {
      return selectCaseUpdatesTranslation(state, caseContent.caseUuid, caseContent.contentUuid);
    });
    var viewOriginalCase = useCallback(function () {
      dispatch(caseActions.viewOriginalCaseTranslation(caseContent.caseUuid));
    }, [caseContent.caseUuid, dispatch]);
    var viewTranslatedCase = useCallback(function () {
      dispatch(caseActions.viewTranslatedCase(caseContent));
    }, [caseContent, dispatch]);
    var toggleTranslation = useCallback(function () {
      if (isViewingTranslation) {
        viewOriginalCase();
      } else {
        viewTranslatedCase();
      }
    }, [isViewingTranslation, viewOriginalCase, viewTranslatedCase]);
    return {
      translation: translation,
      updateTranslations: updateTranslations,
      isLoadingTranslation: isLoadingTranslation,
      isViewingTranslation: isViewingTranslation,
      isTranslationEnabled: isTranslationEnabled,
      toggleTranslation: toggleTranslation,
      viewTranslatedCase: viewTranslatedCase,
      viewOriginalCase: viewOriginalCase
    };
  };
};

/** @format */

var makeUseCommentTranslation = function makeUseCommentTranslation(commentActions) {
  return function (caseUuid, commentUuid) {
    var dispatch = useDispatch();
    var isTranslationEnabled = useSelector(function (state) {
      return selectIsTranslationEnabled(state, commentUuid, caseUuid);
    });
    var isLoadingTranslation = useSelector(function (state) {
      return selectIsLoadingTranslation(state, commentUuid);
    });
    var isViewingTranslation = useSelector(function (state) {
      return selectIsViewingTranslation(state, commentUuid);
    });
    var text = useSelector(function (state) {
      return selectCommentTranslation(state, commentUuid, caseUuid);
    });
    var cachedComment = useSelector(function (state) {
      var _state$comment, _state$comment$cache;

      return (_state$comment = state.comment) === null || _state$comment === void 0 ? void 0 : (_state$comment$cache = _state$comment.cache) === null || _state$comment$cache === void 0 ? void 0 : _state$comment$cache[caseUuid];
    });

    if (commentUuid === "cache") {
      return {
        text: cachedComment === null || cachedComment === void 0 ? void 0 : cachedComment.text,
        isLoadingTranslation: false,
        isViewingTranslation: false,
        isTranslationEnabled: false,
        toggleTranslation: function toggleTranslation() {}
      };
    }

    var toggleTranslation = useCallback(function () {
      if (isViewingTranslation) {
        dispatch(commentActions.viewOriginalComment(commentUuid));
      } else {
        dispatch(commentActions.viewTranslatedComment(commentUuid, caseUuid));
      }
    }, [commentUuid, caseUuid, dispatch, isViewingTranslation]);
    return {
      text: text,
      isLoadingTranslation: isLoadingTranslation,
      isViewingTranslation: isViewingTranslation,
      isTranslationEnabled: isTranslationEnabled,
      toggleTranslation: toggleTranslation
    };
  };
};

var useIsAnonymousCaseAuthor = function useIsAnonymousCaseAuthor(caseUuid) {
  return useSelector(function (state) {
    var _state$anonymousAutho, _state$anonymousAutho2;

    return ((_state$anonymousAutho = state.anonymousAuthors) === null || _state$anonymousAutho === void 0 ? void 0 : (_state$anonymousAutho2 = _state$anonymousAutho.anonymousCaseUuids) === null || _state$anonymousAutho2 === void 0 ? void 0 : _state$anonymousAutho2.indexOf(caseUuid)) > -1;
  });
};

var useIsAnonymousCommentAuthor = function useIsAnonymousCommentAuthor(commentUuid) {
  return useSelector(function (state) {
    var _state$anonymousAutho, _state$anonymousAutho2;

    return ((_state$anonymousAutho = state.anonymousAuthors) === null || _state$anonymousAutho === void 0 ? void 0 : (_state$anonymousAutho2 = _state$anonymousAutho.anonymousCommentUuids) === null || _state$anonymousAutho2 === void 0 ? void 0 : _state$anonymousAutho2.indexOf(commentUuid)) > -1;
  });
};

/** @format */

var useIsCaseAuthor = function useIsCaseAuthor(caseContent) {
  var _caseContent$authors, _caseContent$authors$;

  /****************************** Config **************************************/
  var isAnonAuthor = useIsAnonymousCaseAuthor(caseContent === null || caseContent === void 0 ? void 0 : caseContent.caseUuid);
  var currentUserUuid = useSelector(function (state) {
    var _state$user;

    return (_state$user = state.user) === null || _state$user === void 0 ? void 0 : _state$user.userUuid;
  });
  var caseAuthorUuid = caseContent === null || caseContent === void 0 ? void 0 : (_caseContent$authors = caseContent.authors) === null || _caseContent$authors === void 0 ? void 0 : (_caseContent$authors$ = _caseContent$authors[0]) === null || _caseContent$authors$ === void 0 ? void 0 : _caseContent$authors$.userUuid;
  return isAnonAuthor || currentUserUuid && caseAuthorUuid === currentUserUuid;
};

var hooks = function hooks(actions) {
  return {
    useCaseTranslation: makeUseCaseTranslation(actions.CaseActions),
    useCommentTranslation: makeUseCommentTranslation(actions.CommentActions),
    useIsAnonymousCaseAuthor: useIsAnonymousCaseAuthor,
    useIsAnonymousCommentAuthor: useIsAnonymousCommentAuthor,
    useIsCaseAuthor: useIsCaseAuthor
  };
};

var selectors = {
  CaseSelectors: CaseSelectors,
  CommentSelectors: CommentSelectors,
  LocalizationSelectors: LocalizationSelectors
};

var getCmeType = function getCmeType(cmeCaseContent) {
  switch (cmeCaseContent.cmeType) {
    case CME_TYPES.CASE_CME:
      {
        return "case";
      }

    case CME_TYPES.ACTIVITY:
      {
        return "activity";
      }

    default:
      {
        return "case";
      }
  }
};

var CmeUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCmeType: getCmeType
});

var utils = {
  CaseUtils: CaseUtils,
  TranslationUtils: TranslationUtils,
  CmeUtils: CmeUtils
};

var Actions = actions;
var Reducers = reducers;
var InitialReducerStates = ReducerStates;
var Constants = constants;
var Hooks = hooks;
var Selectors = selectors;
var Utils = utils;

export { Actions, Constants, Hooks, InitialReducerStates, Reducers, Selectors, Utils };
